<template>
    <div style="padding: 16px 24px">
        <el-tabs v-model="tab">
            <el-tab-pane label="弹夹管理" name="ammo">
                <div style="margin-bottom: 12px; display: flex; flex-wrap: wrap; gap: 8px; align-items: center">
                    <el-select v-model="ammoFilter.provider" clearable placeholder="服务商" style="width: 140px"
                               @change="loadAmmo">
                        <el-option label="Premiumads" value="premiumads"/>
                        <el-option label="Reklamup" value="reklamup"/>
                        <el-option label="A4G" value="a4g"/>
                        <el-option label="Bidderdesk" value="bidderdesk"/>
                    </el-select>
                    <el-input v-model="ammoFilter.search" placeholder="搜索批次ID" clearable style="width: 180px"
                              @keyup.enter="loadAmmo"/>
                    <el-button type="primary" @click="loadAmmo">查询</el-button>
                    <el-button type="success" @click="openPush">压入新弹夹</el-button>
                    <el-button type="warning" @click="openBidderdeskCreate">按模版创建Bidderdesk弹夹</el-button>
                </div>
                <el-table :data="ammoList" v-loading="ammoLoading" border style="width: 100%">
                    <el-table-column prop="batch_id" label="批次ID" width="200"/>
                    <el-table-column prop="provider" label="服务商" width="120"/>
                    <el-table-column prop="pushed_at" label="压入时间" width="170"/>
                    <el-table-column prop="status" label="状态" width="100"/>
                    <el-table-column prop="entries_count" label="条目数" width="80"/>
                    <el-table-column prop="default_consumption_count" label="默认记录" width="90"/>
                    <el-table-column prop="experiment_consumption_count" label="实验记录" width="90"/>
                    <el-table-column label="操作" width="200" fixed="right">
                        <template #default="scope">
                            <el-button link type="primary" @click="openAmmoDetail(scope.row.batch_id)">详情</el-button>
                            <el-button link type="danger" @click="deleteAmmoRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    v-model:current-page="ammoPage.page"
                    v-model:page-size="ammoPage.size"
                    :total="ammoPage.total"
                    layout="total, prev, pager, next"
                    small
                    style="margin-top: 12px"
                    @current-change="loadAmmo"
                />
            </el-tab-pane>
            <el-tab-pane label="策略管理" name="strategy">
                <div style="margin-bottom: 12px; display: flex; gap: 8px; align-items: center">
                    <el-button type="primary" :disabled="strategyActionBusy" @click="openStrategyDialog">创建策略</el-button>
                    <el-button type="danger" plain :loading="isProviderCleanupAction" :disabled="strategyActionBusy"
                               @click="openProviderCleanupDialog">移除配置</el-button>
                    <el-button type="warning" :loading="isManualRunAction" :disabled="strategyActionBusy"
                               @click="openManualRunDialog">{{ manualRunButtonText }}</el-button>
                </div>
                <el-table :data="strategyList" v-loading="strategyLoading" border>
                    <el-table-column prop="name" label="名称" width="160"/>
                    <el-table-column label="广告单元" min-width="220">
                        <template #default="scope">
                            <div v-for="u in strategyUnitPreview(scope.row)" :key="u.unit_id" class="unit-name-line">
                                {{ u.unit_name || u.unit_id }}
                            </div>
                            <span v-if="(scope.row.unit_infos || scope.row.unit_ids || []).length > 2"
                                  style="color: var(--el-text-color-secondary); font-size: 12px">
                                另 {{ (scope.row.unit_infos || scope.row.unit_ids || []).length - 2 }} 个
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="下次执行" width="170" prop="next_run_at"/>
                    <el-table-column label="状态" width="120" prop="status"/>
                    <el-table-column label="暂停" width="80">
                        <template #default="scope">
                            <el-tag :type="scope.row.paused ? 'warning' : 'success'" size="small">
                                {{ scope.row.paused ? '是' : '否' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="600" fixed="right">
                        <template #default="scope">
                            <el-button link type="primary" :disabled="strategyActionBusy"
                                       @click="openStrategyDetail(scope.row)">查看</el-button>
                            <el-button v-if="scope.row.status !== 'done'" link type="primary"
                                       :disabled="strategyActionBusy" @click="openEditStrategy(scope.row)">编辑</el-button>
                            <el-button link type="success" :disabled="strategyActionBusy"
                                       @click="openCopyStrategy(scope.row)">复制</el-button>
                            <el-tooltip content="策略已暂停，无法立即执行" placement="top"
                                        :disabled="!scope.row.paused">
                                <span style="display: inline-flex; vertical-align: middle">
                                    <el-button link type="primary" :loading="isStrategyAction(scope.row, 'run')"
                                               :disabled="scope.row.paused || strategyActionBusy"
                                               @click="runStrategy(scope.row)">{{ strategyRunButtonText(scope.row) }}</el-button>
                                </span>
                            </el-tooltip>
                            <el-button v-if="strategyCanApplyCountryRules(scope.row)" link type="warning"
                                       :loading="isStrategyAction(scope.row, 'apply_country_rules')"
                                       :disabled="strategyActionBusy"
                                       @click="applyCountryRules(scope.row)">{{ strategyApplyCountryRulesButtonText(scope.row) }}</el-button>
                            <el-button v-if="isBidderdeskStrategy(scope.row)" link type="warning"
                                       :loading="isStrategyAction(scope.row, 'cleanup')"
                                       :disabled="strategyActionBusy"
                                       @click="cleanupBidderdeskPlacements(scope.row)">{{ strategyCleanupButtonText(scope.row) }}</el-button>
                            <el-button link :disabled="strategyActionBusy"
                                       @click="togglePause(scope.row)">{{ scope.row.paused ? '恢复' : '暂停' }}</el-button>
                            <el-button link type="danger" :loading="isStrategyAction(scope.row, 'delete')"
                                       :disabled="strategyActionBusy"
                                       @click="removeStrategy(scope.row)">{{ strategyDeleteButtonText(scope.row) }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <el-dialog v-model="pushOpen" title="压入新弹夹" width="920px" destroy-on-close>
            <el-form label-width="100px">
                <el-form-item label="服务商" required>
                    <el-radio-group v-model="pushForm.provider">
                        <el-radio label="premiumads">Premiumads</el-radio>
                        <el-radio label="reklamup">Reklamup</el-radio>
                        <el-radio label="a4g">A4G</el-radio>
                        <el-radio label="bidderdesk">Bidderdesk</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="配置内容" required>
                    <div style="display: flex; flex-direction: column; gap: 8px">
                        <el-input v-model="pushForm.text" type="textarea" :rows="12"
                                  placeholder="每个批次第一行须为表头，且包含列名 Type、AdCode、D.eCPM（可粘贴整表 CSV）。数据行从第二行起；空行分隔多个批次，每批均需自带表头&#10;提交时仅上传这三列（Tab 拼接），与后端弹夹格式一致"/>
                        <div>
                            <el-button type="primary" plain @click="runAmmoPreview">格式化预览</el-button>
                            <span style="margin-left: 10px; color: var(--el-text-color-secondary); font-size: 12px">
                                按表头解析三列并校验；压入时只发送 Type / AdCode / D.eCPM
                            </span>
                        </div>
                    </div>
                </el-form-item>
                <template v-if="ammoPreview">
                    <el-alert v-if="ammoPreview.topError" :title="ammoPreview.topError" type="warning" show-icon
                              :closable="false" style="margin-bottom: 12px"/>
                    <div v-if="ammoPreview.batches && ammoPreview.batches.length" style="max-height: 360px; overflow: auto">
                        <div style="font-weight: 600; margin-bottom: 8px">
                            预览结果
                            <span v-if="ammoPreview.batchCount != null" style="font-weight: normal; color: var(--el-text-color-secondary)">
                                （共 {{ ammoPreview.batchCount }} 个批次）
                            </span>
                        </div>
                        <el-card v-for="b in ammoPreview.batches" :key="b.index" shadow="never" style="margin-bottom: 10px">
                            <template #header>
                                <span>批次 #{{ b.index }}</span>
                                <el-tag v-if="b.parseError" type="danger" size="small" style="margin-left: 8px">错误</el-tag>
                                <el-tag v-else type="success" size="small" style="margin-left: 8px">{{ b.entries.length }} 条</el-tag>
                            </template>
                            <el-alert v-if="b.parseError" :title="b.parseError" type="error" :closable="false" show-icon/>
                            <el-table v-else :data="b.entries" size="small" border style="width: 100%">
                                <el-table-column prop="Type" label="Type" width="80"/>
                                <el-table-column prop="AdCode" label="AdCode" min-width="200" show-overflow-tooltip/>
                                <el-table-column label="D.eCPM" width="100">
                                    <template #default="scope">
                                        {{ scope.row['D.eCPM'] }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </div>
                </template>
            </el-form>
            <template #footer>
                <el-button @click="pushOpen = false">取消</el-button>
                <el-button type="primary" :loading="pushLoading" @click="submitPush">确认压入</el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="bidderdeskOpen" title="按模版创建Bidderdesk弹夹" width="980px" destroy-on-close>
            <div v-loading="bidderdeskLoading">
                <el-form label-width="110px">
                    <el-form-item label="基础前缀">
                        <el-input v-model="bidderdeskForm.base_prefix" style="width: 220px" placeholder="默认 MAX"/>
                        <span style="margin-left: 10px; color: var(--el-text-color-secondary); font-size: 12px">
                            最终 AdCode：{{ bidderdeskBatchPrefixPreview }}_Type_D.eCPM
                        </span>
                    </el-form-item>
                    <el-form-item label="批次时间">
                        <el-input v-model="bidderdeskForm.batch_time" clearable style="width: 220px"
                                  placeholder="留空使用当前 UTC+8"/>
                        <span style="margin-left: 10px; color: var(--el-text-color-secondary); font-size: 12px">
                            格式 YYMMDDHHMMSS，例如 260512171211；留空由后端按运行时间生成
                        </span>
                    </el-form-item>
                    <el-form-item label="广告模板 JSON" required>
                        <el-input v-model="bidderdeskTemplateText" type="textarea" :rows="14"
                                  placeholder="模板数组 JSON，可修改 type / d_ecpm / sizes / refresh_delay_seconds 等字段"/>
                    </el-form-item>
                    <el-form-item label="订单模板 JSON" required>
                        <el-input v-model="bidderdeskOrderTemplateText" type="textarea" :rows="8"
                                  placeholder="订单模板对象 JSON，按 BN / INT / RW 配置 template_order_id 和 name_prefix"/>
                    </el-form-item>
                    <template v-if="bidderdeskPreviewRows.length">
                        <div style="margin-bottom: 8px; font-weight: 600">
                            模板预览（{{ bidderdeskPreviewRows.length }} 条）
                        </div>
                        <el-table :data="bidderdeskPreviewRows" size="small" border max-height="300" style="width: 100%">
                            <el-table-column prop="type" label="Type" width="80"/>
                            <el-table-column prop="ad_code" label="AdCode 预览" min-width="220" show-overflow-tooltip/>
                            <el-table-column prop="d_ecpm" label="D.eCPM" width="100"/>
                            <el-table-column prop="source_ad_code" label="模板来源" min-width="140" show-overflow-tooltip/>
                            <el-table-column prop="sizes_text" label="尺寸/环境" min-width="220" show-overflow-tooltip/>
                            <el-table-column prop="refresh_delay_seconds" label="刷新" width="80"/>
                        </el-table>
                    </template>
                    <el-alert v-if="bidderdeskDryRunResult" type="success" show-icon :closable="false"
                              style="margin-top: 12px"
                              :title="'dry-run 通过：' + ((bidderdeskDryRunResult.entries || []).length) + ' 条，批次前缀 ' + bidderdeskDryRunResult.batch_prefix + '，计划订单 ' + ((bidderdeskDryRunResult.order_plan || []).length) + ' 个'"/>
                </el-form>
            </div>
            <template #footer>
                <el-button @click="bidderdeskOpen = false">取消</el-button>
                <el-button :loading="bidderdeskSubmitLoading" @click="submitBidderdeskCreate(true)">Dry-run预览</el-button>
                <el-button type="primary" :loading="bidderdeskSubmitLoading" @click="submitBidderdeskCreate(false)">
                    确认创建并压入弹夹
                </el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="detailOpen" title="弹夹详情" width="800px">
            <template v-if="ammoDetail">
                <p><b>批次</b> {{ ammoDetail.batch_id }} &nbsp; <b>服务商</b> {{ ammoDetail.provider }}</p>
                <p><b>压入时间</b> {{ ammoDetail.pushed_at }}</p>
                <el-table :data="ammoDetail.entries" size="small" border style="margin-top: 8px">
                    <el-table-column prop="Type" label="Type" width="80"/>
                    <el-table-column prop="AdCode" label="AdCode" show-overflow-tooltip/>
                    <el-table-column prop="D.eCPM" label="D.eCPM" width="100"/>
                </el-table>
                <h4 style="margin-top: 16px">消费记录</h4>
                <div style="margin: 8px 0; color: var(--el-text-color-secondary); font-size: 13px">默认瀑布</div>
                <el-table :data="ammoDetail.default_consumption || []" size="small" border empty-text="暂无默认记录">
                    <el-table-column prop="unit_name" label="广告单元" min-width="220" show-overflow-tooltip/>
                    <el-table-column prop="consumed_at" label="时间" width="200"/>
                </el-table>
                <div style="margin: 16px 0 8px; color: var(--el-text-color-secondary); font-size: 13px">Mediation 实验组</div>
                <el-table :data="ammoDetail.experiment_consumption || []" size="small" border empty-text="暂无实验组记录">
                    <el-table-column prop="unit_name" label="广告单元" min-width="220" show-overflow-tooltip/>
                    <el-table-column prop="experiment_name" label="实验名称" min-width="180" show-overflow-tooltip>
                        <template #default="scope">{{ scope.row.experiment_name || '—' }}</template>
                    </el-table-column>
                    <el-table-column prop="consumed_at" label="时间" width="200"/>
                </el-table>
            </template>
            <template #footer>
                <el-button type="danger" @click="deleteAmmo">删除弹夹</el-button>
                <el-button @click="detailOpen = false">关闭</el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="strategyDetailOpen" title="策略详情" width="760px" destroy-on-close>
            <div v-loading="strategyDetailLoading" style="min-height: 120px">
                <template v-if="strategyDetail">
                    <el-form label-width="120px" class="strategy-detail-form">
                        <el-form-item label="名称">{{ strategyDetail.name }}</el-form-item>
                        <el-form-item label="策略 ID">
                            <span style="word-break: break-all">{{ strategyDetail.id }}</span>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-tag size="small">{{ strategyDetail.status }}</el-tag>
                            <el-tag :type="strategyDetail.paused ? 'warning' : 'success'" size="small" style="margin-left: 8px">
                                {{ strategyDetail.paused ? '已暂停' : '运行中' }}
                            </el-tag>
                        </el-form-item>
                        <el-form-item label="调度类型">{{ strategyScheduleLabel(strategyDetail.schedule_type) }}</el-form-item>
                        <el-form-item v-if="strategyDetail.schedule_type==='once'" label="执行时间">
                            {{ strategyDetail.run_at || '—' }}
                        </el-form-item>
                        <template v-if="strategyDetail.schedule_type==='repeat'">
                            <el-form-item label="首次执行">{{ strategyDetail.first_run_at || '—' }}</el-form-item>
                            <el-form-item label="间隔(小时)">{{ strategyDetail.interval_hours }}</el-form-item>
                        </template>
                        <template v-if="strategyDetail.schedule_type==='weekdays'">
                            <el-form-item label="星期">{{ formatWeekdays(strategyDetail.weekdays) }}</el-form-item>
                            <el-form-item label="执行时刻">{{ strategyDetail.weekday_run_time || '—' }}</el-form-item>
                        </template>
                        <el-form-item v-if="strategyDetail.ad_update_target === 'experiment_only'" label="更新范围">
                            仅 Mediation 实验组瀑布
                        </el-form-item>
                        <el-form-item label="下次执行">{{ strategyDetail.next_run_at || '—' }}</el-form-item>
                        <el-form-item label="上次执行">{{ strategyDetail.last_run_at || '—' }}</el-form-item>
                        <el-form-item label="广告单元">
                            <span style="color: var(--el-text-color-secondary)">共 {{ (strategyDetail.unit_ids || []).length }} 个</span>
                        </el-form-item>
                        <el-table :data="strategyUnitRows" size="small" border max-height="220" style="width: 100%">
                            <el-table-column type="index" label="#" width="50"/>
                            <el-table-column prop="unit_name" label="Max 广告单元" min-width="240" show-overflow-tooltip/>
                            <el-table-column v-if="strategyDetail.ad_update_target === 'experiment_only'"
                                             prop="experiment_name" label="实验名称" min-width="180" show-overflow-tooltip>
                                <template #default="scope">{{ scope.row.experiment_name || '—' }}</template>
                            </el-table-column>
                        </el-table>
                        <div style="margin: 16px 0 8px; font-weight: 600">服务商订阅</div>
                        <el-table :data="strategyDetail.subscriptions || []" size="small" border style="width: 100%">
                            <el-table-column label="服务商" width="120">
                                <template #default="scope">
                                    {{ gamProviderLabel(scope.row.provider) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="起始批次" min-width="160" show-overflow-tooltip>
                                <template #default="scope">{{ batchLabel(scope.row.start_batch_id) }}</template>
                            </el-table-column>
                            <el-table-column label="当前指针" min-width="160" show-overflow-tooltip>
                                <template #default="scope">{{ batchLabel(scope.row.cursor_batch_id) }}</template>
                            </el-table-column>
                        </el-table>
                        <el-form-item label="关联产品 ID" style="margin-top: 12px">
                            <span style="word-break: break-all; font-size: 12px">{{ (strategyDetail.product_ids || []).join(', ') || '—' }}</span>
                        </el-form-item>
                        <template v-if="strategyDetail.policy_config && Object.keys(strategyDetail.policy_config).length">
                            <div style="margin: 16px 0 8px; font-weight: 600">实验策略</div>
                            <el-form-item label="国家定向">
                                <span>{{ policyCountrySummary(strategyDetail.policy_config) }}</span>
                            </el-form-item>
                            <el-form-item label="正则替换">
                                <span>{{ policyProviderSummary(strategyDetail.policy_config) }}</span>
                            </el-form-item>
                        </template>
                    </el-form>
                </template>
            </div>
            <template #footer>
                <el-button v-if="strategyDetail && strategyDetail.status !== 'done'" type="primary" @click="editFromDetail">编辑</el-button>
                <el-button @click="strategyDetailOpen = false">关闭</el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="providerCleanupOpen" title="移除配置" width="980px" destroy-on-close
                   @closed="onProviderCleanupClosed">
            <div v-loading="providerCleanupLoading">
                <el-alert type="warning" show-icon :closable="false" style="margin-bottom: 12px"
                          title="该操作会从所选广告单元的 GAM / GAM Native 瀑布中删除命中正则的 placement。若后续策略仍订阅对应服务商，再次执行时可能重新写入。"/>
                <el-form label-width="110px">
                    <el-form-item label="服务商" required>
                        <div style="width: 100%">
                            <el-checkbox-group v-model="providerCleanupForm.providers">
                                <el-checkbox v-for="p in providerCleanupSpecs" :key="p.key" :label="p.key">
                                    {{ p.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <div v-if="providerCleanupSelectedSpecs.length" class="provider-regex-list">
                                <div v-for="p in providerCleanupSelectedSpecs" :key="p.key" class="provider-regex-item">
                                    <strong>{{ p.label }}</strong>
                                    <code v-for="pattern in p.patterns" :key="pattern">{{ pattern }}</code>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="生效范围" required>
                        <el-radio-group v-model="providerCleanupForm.target" @change="onProviderCleanupTargetChange">
                            <el-radio label="default_only">仅默认瀑布</el-radio>
                            <el-radio label="both">默认瀑布 + 实验组</el-radio>
                            <el-radio label="experiment_only">仅实验组</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="从策略复制">
                        <el-select v-model="providerCleanupSourceStrategyId" clearable filterable
                                   placeholder="可选：复制其它策略的广告单元" style="width: 100%"
                                   @change="copyProviderCleanupUnitsFromStrategy">
                            <el-option v-for="s in strategyList" :key="s.id"
                                       :label="`${s.name || s.id} · ${(s.unit_ids || []).length}个ADUnit`"
                                       :value="s.id"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选产品">
                        <el-select v-model="providerCleanupProductFilter" multiple clearable filterable collapse-tags
                                   placeholder="不选则显示全部广告单元" style="width: 100%"
                                   @change="syncProviderCleanupSelection">
                            <el-option v-for="p in $root.product_list" :key="p.id"
                                       :label="(p.name || p.nickname) + ' ' + p.platform" :value="p.id"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="广告单元" required>
                        <div style="width: 100%">
                            <div style="margin-bottom: 8px; display: flex; gap: 8px; align-items: center">
                                <el-input v-model="providerCleanupUnitSearch" clearable placeholder="按名称搜索"
                                          style="width: 220px" @input="syncProviderCleanupSelection"/>
                                <span style="color: var(--el-text-color-secondary)">
                                    已选 {{ providerCleanupSelectedUnitCount }} 个
                                </span>
                            </div>
                            <el-table ref="providerCleanupUnitsTable" :data="providerCleanupUnitsFiltered"
                                      :row-key="(row) => String(row.id)" max-height="380" border
                                      @selection-change="onProviderCleanupSelectionChange">
                                <el-table-column type="selection" width="48" :reserve-selection="true"/>
                                <el-table-column prop="name" label="Name" min-width="180" show-overflow-tooltip/>
                                <el-table-column label="产品" min-width="220">
                                    <template #default="scope">
                                        <template v-for="p in $root.product_list">
                                            <span v-if="scope.row.package_name === p.bundle_id && scope.row.platform === p.platform"
                                                  :key="p.id">
                                                {{ p.name || p.nickname }} ({{ p.platform }})
                                            </span>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column label="格式" width="100">
                                    <template #default="scope">{{ adFormatLabel(scope.row.ad_format) }}</template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <el-button @click="providerCleanupOpen = false">取消</el-button>
                <el-button type="danger" :loading="isProviderCleanupAction" @click="submitProviderCleanup">
                    {{ isProviderCleanupAction ? `移除中${strategyActionProgressText()}` : '确认移除' }}
                </el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="strategyOpen" :title="strategyEditId ? '编辑策略' : '创建策略'" width="920px" destroy-on-close
                   @closed="onStrategyDialogClosed">
            <el-alert v-if="strategyEditId" type="info" show-icon :closable="false" style="margin-bottom: 12px"
                      title="保存后将按当前「起始批次」重建订阅，游标会重置为起始批次；调度将重新计算下次执行时间。"/>
            <el-form :model="strategyForm" label-width="110px">
                <el-form-item label="名称" required>
                    <el-input v-model="strategyForm.name" placeholder="策略名称"/>
                </el-form-item>
                <el-form-item label="筛选产品">
                    <el-select v-model="strategyUnitProductFilter" multiple clearable filterable collapse-tags
                               placeholder="不选则显示全部广告单元" style="width: 100%"
                               @change="onStrategyUnitFilterChange">
                        <el-option v-for="p in $root.product_list" :key="p.id"
                                   :label="(p.name || p.nickname) + ' ' + p.platform" :value="p.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="广告单元" required>
                    <div style="margin-bottom: 8px; display: flex; flex-direction: column; gap: 8px">
                        <div style="color: var(--el-text-color-secondary); font-size: 12px; line-height: 1.5">
                            默认策略会更新默认瀑布，并对<strong>未</strong>单独配置「实验组策略」的单元同步实验瀑布；若某单元已在另一条「实验组策略」中，默认策略将跳过该单元，由该实验组策略在调度时间只更新其实验瀑布。
                        </div>
                        <el-checkbox v-model="strategyExperimentMode" @change="onStrategyExperimentModeChange">
                            Mediation 实验组策略：列表只显示有实验的广告单元；保存后本策略仅更新实验瀑布，且其它默认策略不再更新所选单元
                        </el-checkbox>
                    </div>
                    <div style="margin-bottom: 8px; display: flex; flex-wrap: wrap; gap: 8px; align-items: center">
                        <el-input v-model="strategyUnitSearch" clearable placeholder="按名称搜索"
                                  style="width: 220px" @input="onStrategyUnitFilterChange"/>
                        <span style="color: var(--el-text-color-secondary)">已选 {{ strategySelectedUnitCount }} 个</span>
                    </div>
                    <el-table ref="strategyUnitsTable" :data="strategyUnitsFiltered" v-loading="strategyUnitsLoading"
                              :row-key="(row) => String(row.id)" max-height="380" border style="width: 100%"
                              @selection-change="onStrategyUnitsSelectionChange">
                        <el-table-column type="selection" width="48" :reserve-selection="true"/>
                        <el-table-column prop="name" label="Name" min-width="180" show-overflow-tooltip/>
                        <el-table-column label="产品" min-width="220">
                            <template #default="scope">
                                <template v-for="p in $root.product_list">
                                    <template
                                        v-if="scope.row.package_name === p.bundle_id && scope.row.platform === p.platform">
                                        <el-image lazy :src="p.avatar" style="width: 23px; vertical-align: middle">
                                            <template #error>
                                                <div class="image-slot">
                                                    <el-icon>
                                                        <Picture/>
                                                    </el-icon>
                                                </div>
                                            </template>
                                        </el-image>
                                        <span style="margin-left: 5px">{{ p.name || p.nickname }} ({{ p.platform }})</span>
                                    </template>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="格式" width="100">
                            <template #default="scope">
                                {{ adFormatLabel(scope.row.ad_format) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item v-for="prov in providerKeys" :key="prov.key" :label="prov.label">
                    <div style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap">
                        <el-checkbox v-model="prov.enabled">订阅</el-checkbox>
                        <el-select v-if="prov.enabled" v-model="prov.start_batch_id" filterable placeholder="起始批次"
                                   style="min-width: 220px" :loading="prov.loading">
                            <el-option label="下一新增批次" :value="nextNewBatchId"/>
                            <el-option v-for="b in prov.batches" :key="b.batch_id" :label="b.batch_id + ' @ ' + b.pushed_at"
                                       :value="b.batch_id"/>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="策略能力">
                    <div style="width: 100%; border: 1px solid var(--el-border-color); border-radius: 4px; padding: 12px">
                        <div style="display: flex; flex-direction: column; gap: 12px">
                            <div>
                                <el-checkbox v-model="strategyPolicyForm.country_targeting.enabled">
                                    按 eCPM 设置 GAM 国家
                                </el-checkbox>
                                <div v-if="strategyPolicyForm.country_targeting.enabled"
                                     style="margin-top: 8px; display: flex; flex-wrap: wrap; gap: 8px; align-items: center">
                                    <el-select v-model="strategyPolicyForm.country_targeting.rule_set_id"
                                               filterable placeholder="选择国家规则集" style="min-width: 320px"
                                               :loading="countryRulesLoading">
                                        <el-option v-for="r in countryRuleSets" :key="r.id"
                                                   :label="countryRuleOptionLabel(r)" :value="r.id"/>
                                    </el-select>
                                    <el-checkbox v-model="strategyPolicyForm.country_targeting.allow_unmatched">
                                        允许未命中
                                    </el-checkbox>
                                    <el-button @click="loadCountryRuleSets">刷新</el-button>
                                    <el-button type="primary" plain @click="openCountryRuleDialog">创建规则集</el-button>
                                    <el-button :disabled="!strategyPolicyForm.country_targeting.rule_set_id"
                                               @click="openSelectedCountryRuleDetail">查看/编辑</el-button>
                                    <el-checkbox v-if="strategyExperimentMode" v-model="strategyApplyCountryRulesAfterSave"
                                                 :disabled="!strategyPolicyForm.country_targeting.rule_set_id">
                                        保存后立即只应用国家
                                    </el-checkbox>
                                </div>
                            </div>
                            <div>
                                <el-checkbox v-model="strategyPolicyForm.provider_regex_replace.enabled">
                                    Provider 正则替换
                                </el-checkbox>
                                <el-checkbox-group v-if="strategyPolicyForm.provider_regex_replace.enabled"
                                                   v-model="strategyPolicyForm.provider_regex_replace.providers"
                                                   style="margin-top: 8px">
                                    <el-checkbox v-for="p in providerKeys" :key="p.key" :label="p.key">
                                        {{ p.label }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="调度" required>
                    <el-radio-group v-model="strategyForm.schedule_type">
                        <el-radio label="once">单次</el-radio>
                        <el-radio label="repeat">按间隔重复</el-radio>
                        <el-radio label="weekdays">按星期</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="strategyForm.schedule_type==='once'" label="执行时间" required>
                    <el-date-picker v-model="strategyForm.run_at" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
                                    placeholder="选择时间"/>
                </el-form-item>
                <template v-if="strategyForm.schedule_type==='repeat'">
                    <el-form-item label="首次执行" required>
                        <el-date-picker v-model="strategyForm.first_run_at" type="datetime"
                                        value-format="YYYY-MM-DD HH:mm:ss" placeholder="首次时间"/>
                    </el-form-item>
                    <el-form-item label="间隔(小时)" required>
                        <el-input-number v-model="strategyForm.interval_hours" :min="1" :max="720"/>
                    </el-form-item>
                </template>
                <template v-if="strategyForm.schedule_type==='weekdays'">
                    <el-form-item label="星期" required>
                        <div style="display: flex; flex-wrap: wrap; gap: 8px; align-items: center">
                            <el-checkbox-group v-model="strategyForm.weekdays">
                                <el-checkbox v-for="w in weekdayOptions" :key="w.v" :label="w.v">{{ w.t }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div style="margin-top: 8px">
                            <el-button size="small" @click="setWeekdayPreset('135')">一三五</el-button>
                            <el-button size="small" style="margin-left: 8px" @click="setWeekdayPreset('246')">二四六</el-button>
                            <el-button size="small" style="margin-left: 8px" @click="setWeekdayPreset('all')">每天</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="执行时刻" required>
                        <el-time-picker v-model="strategyForm.weekday_run_time" value-format="HH:mm:ss"
                                        placeholder="如 10:00:00"/>
                        <span style="margin-left: 8px; color: var(--el-text-color-secondary); font-size: 12px">
                            在选中星期的该时刻执行（东八区）
                        </span>
                    </el-form-item>
                </template>
            </el-form>
            <template #footer>
                <el-button @click="closeStrategyDialog">取消</el-button>
                <el-button type="primary" :loading="strategySubmitLoading" @click="submitStrategy">
                    {{ strategyEditId ? '保存' : '创建' }}
                </el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="countryRuleOpen" title="创建国家规则集" width="760px" destroy-on-close>
            <el-form label-width="120px">
                <el-form-item label="来源">
                    <el-radio-group v-model="countryRuleForm.source">
                        <el-radio label="csv">CSV</el-radio>
                        <el-radio label="report">MAX Report</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="名称" required>
                    <el-input v-model="countryRuleForm.name" placeholder="规则集名称"/>
                </el-form-item>
                <el-form-item label="产品 ID">
                    <el-input v-model="countryRuleForm.product_id" placeholder="可选，用于列表筛选和复盘"/>
                </el-form-item>
                <template v-if="countryRuleForm.source === 'csv'">
                    <el-form-item label="CSV" required>
                        <el-input v-model="countryRuleForm.csv_text" type="textarea" :rows="12"
                                  placeholder="min_ecpm,max_ecpm,countrys&#10;0,0.1,NONE&#10;0.11,0.31,&quot;-United States,Canada&quot;"/>
                    </el-form-item>
                </template>
                <template v-else>
                    <el-form-item label="ADUnit 范围">
                        <span style="color: var(--el-text-color-secondary)">
                            将按当前策略已选 {{ strategySelectedUnitCount }} 个 ADUnit ID 过滤 MAX Report，并分别生成独立规则
                        </span>
                    </el-form-item>
                    <el-form-item label="Report 日期" required>
                        <div style="display: flex; gap: 8px; flex-wrap: wrap">
                            <el-date-picker v-model="countryRuleForm.start" type="date" value-format="YYYY-MM-DD"
                                            placeholder="开始日期"/>
                            <el-date-picker v-model="countryRuleForm.end" type="date" value-format="YYYY-MM-DD"
                                            placeholder="结束日期"/>
                        </div>
                    </el-form-item>
                    <el-form-item label="覆盖区间">
                        <div style="display: flex; gap: 8px; flex-wrap: wrap">
                            <el-input v-model="countryRuleForm.coverage_min_ecpm" style="width: 110px" placeholder="min"/>
                            <el-input v-model="countryRuleForm.coverage_max_ecpm" style="width: 110px" placeholder="max"/>
                            <el-input v-model="countryRuleForm.coverage_step" style="width: 110px" placeholder="step"/>
                        </div>
                    </el-form-item>
                    <el-form-item label="Placement 诊断">
                        <el-input v-model="countryRuleForm.network_placements_text" type="textarea" :rows="4"
                                  placeholder="可选，仅记录到任务 payload/summary 供排查；规则生成按当前已选 ADUnit ID 过滤，不按 placement 过滤"/>
                    </el-form-item>
                </template>
            </el-form>
            <template #footer>
                <el-button @click="countryRuleOpen = false">取消</el-button>
                <el-button type="primary" :loading="countryRuleSubmitLoading" @click="submitCountryRule">
                    创建
                </el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="countryRuleDetailOpen" title="国家规则集" width="980px" destroy-on-close>
            <template v-if="countryRuleDetailLoading">
                <el-skeleton :rows="8" animated/>
            </template>
            <template v-else-if="countryRuleEditForm.id">
                <el-form label-width="90px">
                    <el-form-item label="名称">
                        <el-input v-model="countryRuleEditForm.name"/>
                    </el-form-item>
                    <el-form-item label="产品 ID">
                        <el-input v-model="countryRuleEditForm.product_id"/>
                    </el-form-item>
                    <el-form-item label="概要">
                        <div style="display: flex; gap: 8px; flex-wrap: wrap; align-items: center">
                            <el-tag size="small">{{ countryRuleEditForm.source || '—' }}</el-tag>
                            <el-tag size="small" type="info">{{ countryRuleEditSummaryText }}</el-tag>
                            <el-tag v-if="countryRuleEditForm.report_start || countryRuleEditForm.report_end"
                                    size="small" type="info">
                                {{ countryRuleEditForm.report_start || '—' }} ~ {{ countryRuleEditForm.report_end || '—' }}
                            </el-tag>
                        </div>
                    </el-form-item>
                    <el-form-item label="规则范围">
                        <el-select v-model="countryRuleEditScope" style="min-width: 320px">
                            <el-option label="全局规则" value="__global__"/>
                            <el-option v-for="u in countryRuleEditUnitOptions" :key="u.unit_id"
                                       :label="u.label" :value="u.unit_id"/>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-table :data="countryRuleEditRows" size="small" border style="width: 100%; margin-top: 8px">
                    <el-table-column label="min eCPM" width="140">
                        <template #default="{row}">
                            <el-input v-model="row.min_ecpm" size="small"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="max eCPM" width="140">
                        <template #default="{row}">
                            <el-input v-model="row.max_ecpm" size="small"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="国家">
                        <template #default="{row}">
                            <el-input v-model="row.countrys" size="small" placeholder="NONE / ALL / us,gb / -us,gb"/>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="90" align="center">
                        <template #default="{ $index }">
                            <el-button link type="danger" @click="removeCountryRuleRow($index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px; display: flex; justify-content: space-between; align-items: center">
                    <el-button @click="addCountryRuleRow">新增行</el-button>
                    <span style="color: var(--el-text-color-secondary); font-size: 12px">
                        保存时后端会校验 eCPM 区间、国家名和重叠区间
                    </span>
                </div>
            </template>
            <template #footer>
                <el-button @click="countryRuleDetailOpen = false">关闭</el-button>
                <el-button type="primary" :loading="countryRuleDetailSaving" @click="saveCountryRuleDetail">
                    保存
                </el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="manualRunOpen" title="手动修复执行" width="720px" destroy-on-close>
            <el-alert type="warning" show-icon :closable="false" style="margin-bottom: 12px"
                      title="手动任务会复制所选策略的广告单元，并使用本次选择的弹夹按正常策略流程立即更新 Max；成功后会写入快照、消费记录并推进策略游标。"/>
            <el-form label-width="110px">
                <el-form-item label="复制策略" required>
                    <el-select v-model="manualRunForm.strategy_id" filterable placeholder="选择要复制 ADUnit 的策略"
                               style="width: 100%" :loading="strategyLoading" @change="onManualRunStrategyChange">
                        <el-option v-for="s in strategyList" :key="s.id"
                                   :label="`${s.name || s.id} · ${s.ad_update_target === 'experiment_only' ? '实验组' : '默认+实验'} · ${((s.unit_ids || []).length)}个ADUnit`"
                                   :value="s.id"/>
                    </el-select>
                </el-form-item>
                <template v-if="manualRunSourceDetail">
                    <el-form-item label="执行范围">
                        <el-tag size="small">
                            {{ manualRunSourceDetail.ad_update_target === 'experiment_only' ? '仅实验组' : '默认组 + 实验组' }}
                        </el-tag>
                        <span style="margin-left: 8px; color: var(--el-text-color-secondary)">
                            已复制 {{ (manualRunSourceDetail.unit_ids || []).length }} 个 ADUnit
                        </span>
                    </el-form-item>
                    <el-form-item v-for="prov in manualProviderKeys" :key="prov.key" :label="prov.label">
                        <div style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap">
                            <el-checkbox v-model="prov.enabled">使用</el-checkbox>
                            <el-select v-if="prov.enabled" v-model="prov.start_batch_id" filterable placeholder="选择弹夹"
                                       style="min-width: 260px" :loading="prov.loading">
                                <el-option v-for="b in prov.batches" :key="b.batch_id"
                                           :label="b.batch_id + ' @ ' + b.pushed_at"
                                           :value="b.batch_id"/>
                            </el-select>
                        </div>
                    </el-form-item>
                </template>
            </el-form>
            <template #footer>
                <el-button @click="manualRunOpen = false">取消</el-button>
                <el-button type="warning" :loading="isManualRunAction" @click="submitManualRun">
                    {{ isManualRunAction ? `执行中${strategyActionProgressText()}` : '立即执行' }}
                </el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import {ElMessage, ElMessageBox} from "element-plus";
import {Picture} from "@element-plus/icons-vue";
import axios from "ts-axios-new";
// selectedMaxUnit：与 GAM.vue 共用 localStorage；无记录时 getLocalObj 的第二个参数才是默认 []，并非任何服务端下发的配置
import {getLocalObj, setLocalObj} from "../../libs/storage";

export default {
    name: "GAMV2",
    components: {Picture},
    data() {
        return {
            tab: 'ammo',
            nextNewBatchId: '__next_new_batch__',
            ammoLoading: false,
            ammoList: [],
            ammoPage: {page: 1, size: 20, total: 0},
            ammoFilter: {provider: '', search: ''},
            pushOpen: false,
            pushLoading: false,
            pushForm: {provider: 'premiumads', text: ''},
            ammoPreview: null,
            detailOpen: false,
            ammoDetail: null,
            strategyLoading: false,
            strategyList: [],
            strategyOpen: false,
            strategyDetailOpen: false,
            strategyDetail: null,
            strategyDetailLoading: false,
            strategySubmitLoading: false,
            strategyEditId: null,
            strategyExperimentMode: false,
            strategyApplyCountryRulesAfterSave: false,
            providerCleanupOpen: false,
            providerCleanupLoading: false,
            providerCleanupSpecs: [],
            providerCleanupForm: {providers: [], target: 'default_only'},
            providerCleanupSourceStrategyId: '',
            providerCleanupMaxUnits: [],
            providerCleanupSelectedUnitIds: [],
            providerCleanupUnitSearch: '',
            providerCleanupProductFilter: [],
            providerCleanupSelectionSyncing: false,
            /** 表格数据刷新/程序勾选时忽略 selection-change，避免清空 strategySelectedUnitIds */
            strategyUnitSelectionSyncing: false,
            strategyMaxUnits: [],
            strategyUnitsLoading: false,
            strategyUnitSearch: '',
            strategyUnitProductFilter: [],
            strategySelectedUnitIds: [],
            strategyForm: {
                name: '',
                schedule_type: 'once',
                run_at: '',
                first_run_at: '',
                interval_hours: 24,
                weekdays: [],
                weekday_run_time: '10:00:00',
            },
            weekdayOptions: [
                {v: 0, t: '周一'}, {v: 1, t: '周二'}, {v: 2, t: '周三'},
                {v: 3, t: '周四'}, {v: 4, t: '周五'}, {v: 5, t: '周六'}, {v: 6, t: '周日'},
            ],
            providerKeys: [
                {key: 'premiumads', label: 'Premiumads', enabled: true, start_batch_id: '', batches: [], loading: false},
                {key: 'reklamup', label: 'Reklamup', enabled: false, start_batch_id: '', batches: [], loading: false},
                {key: 'a4g', label: 'A4G', enabled: false, start_batch_id: '', batches: [], loading: false},
                {key: 'bidderdesk', label: 'Bidderdesk', enabled: false, start_batch_id: '', batches: [], loading: false},
            ],
            strategyPolicyForm: {
                country_targeting: {enabled: false, rule_set_id: '', allow_unmatched: false},
                provider_regex_replace: {enabled: false, providers: []},
            },
            countryRuleSets: [],
            countryRulesLoading: false,
            countryRuleOpen: false,
            countryRuleSubmitLoading: false,
            countryRuleDetailOpen: false,
            countryRuleDetailLoading: false,
            countryRuleDetailSaving: false,
            countryRuleEditScope: '__global__',
            countryRuleEditForm: {
                id: '',
                name: '',
                product_id: '',
                source: '',
                report_start: '',
                report_end: '',
                summary: {},
                rules: [],
                unit_rules: {},
            },
            countryRuleForm: {
                source: 'csv',
                name: '',
                product_id: '',
                csv_text: '',
                start: '',
                end: '',
                coverage_min_ecpm: '0',
                coverage_max_ecpm: '93',
                coverage_step: '0.01',
                network_placements_text: '',
            },
            bidderdeskOpen: false,
            bidderdeskLoading: false,
            bidderdeskSubmitLoading: false,
            bidderdeskForm: {base_prefix: 'MAX', batch_time: ''},
            bidderdeskTemplateText: '',
            bidderdeskOrderTemplateText: '',
            bidderdeskDryRunResult: null,
            manualRunOpen: false,
            manualRunForm: {strategy_id: ''},
            manualRunSourceDetail: null,
            manualProviderKeys: [
                {key: 'premiumads', label: 'Premiumads', enabled: true, start_batch_id: '', batches: [], loading: false},
                {key: 'reklamup', label: 'Reklamup', enabled: false, start_batch_id: '', batches: [], loading: false},
                {key: 'a4g', label: 'A4G', enabled: false, start_batch_id: '', batches: [], loading: false},
                {key: 'bidderdesk', label: 'Bidderdesk', enabled: false, start_batch_id: '', batches: [], loading: false},
            ],
            strategyAction: {type: '', rowId: '', done: 0, total: 0},
        };
    },
    mounted() {
        this.loadAmmo();
        this.loadStrategies();
        this.loadCountryRuleSets();
    },
    computed: {
        strategyUnitRows() {
            if (!this.strategyDetail) return [];
            const infos = this.strategyDetail.unit_infos || [];
            if (infos.length) {
                return infos.map((u) => ({
                    unit_id: String(u.unit_id || ''),
                    unit_name: u.unit_name || u.unit_id || '—',
                    experiment_name: u.experiment_name || '',
                }));
            }
            const ids = this.strategyDetail.unit_ids || [];
            return ids.map((unit_id) => ({
                unit_id,
                unit_name: unit_id,
                experiment_name: '',
            }));
        },
        strategyUnitsFiltered() {
            let rows = this.strategyMaxUnits || [];
            const q = (this.strategyUnitSearch || '').trim().toLowerCase();
            if (q) {
                rows = rows.filter(d => (d.name || '').toLowerCase().includes(q));
            }
            const pf = this.strategyUnitProductFilter || [];
            if (pf.length) {
                const plist = this.$root.product_list || [];
                const allowed = new Set(pf);
                rows = rows.filter(d => plist.some(p =>
                    allowed.has(p.id) && d.package_name === p.bundle_id && d.platform === p.platform,
                ));
            }
            return rows;
        },
        providerCleanupUnitsFiltered() {
            let rows = this.providerCleanupMaxUnits || [];
            const q = (this.providerCleanupUnitSearch || '').trim().toLowerCase();
            if (q) {
                rows = rows.filter((d) => (d.name || '').toLowerCase().includes(q));
            }
            const pf = this.providerCleanupProductFilter || [];
            if (pf.length) {
                const plist = this.$root.product_list || [];
                const allowed = new Set(pf);
                rows = rows.filter((d) => plist.some((p) => (
                    allowed.has(p.id) && d.package_name === p.bundle_id && d.platform === p.platform
                )));
            }
            return rows;
        },
        providerCleanupSelectedUnitCount() {
            return new Set((this.providerCleanupSelectedUnitIds || []).map((id) => String(id))).size;
        },
        providerCleanupSelectedSpecs() {
            const selected = new Set(this.providerCleanupForm.providers || []);
            return (this.providerCleanupSpecs || []).filter((p) => selected.has(p.key));
        },
        /** 去重后的已选数量（避免 reserve-selection / 合并逻辑导致 length 虚高） */
        strategySelectedUnitCount() {
            return new Set((this.strategySelectedUnitIds || []).map((id) => String(id))).size;
        },
        isBidderdeskStrategy() {
            return (row) => (row && row.subscriptions || []).some((s) => s && s.provider === 'bidderdesk');
        },
        strategyCanApplyCountryRules() {
            return (row) => {
                const policy = row && row.policy_config || {};
                const cfg = policy.country_targeting || {};
                return row && row.ad_update_target === 'experiment_only' && cfg.enabled && cfg.rule_set_id;
            };
        },
        strategyActionBusy() {
            return !!this.strategyAction.type;
        },
        isManualRunAction() {
            return this.strategyAction.type === 'manual_run';
        },
        isProviderCleanupAction() {
            return this.strategyAction.type === 'provider_cleanup';
        },
        manualRunButtonText() {
            return this.isManualRunAction ? `手动执行中${this.strategyActionProgressText()}` : '手动修复执行';
        },
        countryRuleEditUnitOptions() {
            const summaryUnits = this.countryRuleEditForm.summary && this.countryRuleEditForm.summary.unit_rules || {};
            const unitRules = this.countryRuleEditForm.unit_rules || {};
            return Object.keys(unitRules).sort().map((unitId) => {
                const summary = summaryUnits[unitId] || {};
                const name = summary.unit_name || unitId;
                const total = summary.total != null ? summary.total : (unitRules[unitId] || []).length;
                return {
                    unit_id: unitId,
                    label: `${name} · ${total}段`,
                };
            });
        },
        countryRuleEditRows() {
            if (this.countryRuleEditScope === '__global__') {
                return this.countryRuleEditForm.rules || [];
            }
            return (this.countryRuleEditForm.unit_rules || {})[this.countryRuleEditScope] || [];
        },
        countryRuleEditSummaryText() {
            const s = this.countryRuleEditForm.summary || {};
            const range = s.min_ecpm != null && s.max_ecpm != null ? `${s.min_ecpm}-${s.max_ecpm}` : '无区间';
            const unitText = s.unit_count ? ` · ${s.unit_count}个ADUnit` : '';
            return `${range} · ${s.total || 0}段${unitText}`;
        },
        bidderdeskBatchPrefixPreview() {
            const base = (this.bidderdeskForm.base_prefix || 'MAX').trim() || 'MAX';
            const bt = (this.bidderdeskForm.batch_time || 'YYMMDDHHMMSS').trim() || 'YYMMDDHHMMSS';
            return `${base}_${bt}`;
        },
        bidderdeskPreviewRows() {
            let tpl;
            try {
                tpl = JSON.parse(this.bidderdeskTemplateText || '[]');
            } catch (e) {
                return [];
            }
            if (!Array.isArray(tpl)) {
                return [];
            }
            const prefix = this.bidderdeskBatchPrefixPreview;
            return tpl.map((item) => {
                const type = String(item.type || item.Type || '').trim().toUpperCase();
                const dEcpm = String(item.d_ecpm ?? item['D.eCPM'] ?? '').trim();
                const sizes = Array.isArray(item.sizes) ? item.sizes : [];
                return {
                    type,
                    d_ecpm: dEcpm,
                    ad_code: `${prefix}_${type}_${dEcpm}`,
                    source_ad_code: item.source_ad_code || item.SourceAdCode || '',
                    sizes_text: sizes.map((s) => `${s.width}x${s.height}/${s.environment_type || ''}`).join(' | '),
                    refresh_delay_seconds: item.refresh_delay_seconds ?? '',
                };
            });
        },
    },
    methods: {
        strategyUnitPreview(row) {
            const infos = row && row.unit_infos || [];
            if (infos.length) {
                return infos.slice(0, 2).map((u) => ({
                    unit_id: String(u.unit_id || ''),
                    unit_name: u.unit_name || u.unit_id || '—',
                }));
            }
            return ((row && row.unit_ids) || []).slice(0, 2).map((unit_id) => ({
                unit_id: String(unit_id),
                unit_name: String(unit_id),
            }));
        },
        adFormatLabel(fmt) {
            const m = {BANNER: 'Banner', INTER: '插屏', REWARD: '激励', NATIVE: 'Native'};
            return m[fmt] || fmt || '—';
        },
        isStrategyAction(row, type) {
            return this.strategyAction.type === type && this.strategyAction.rowId === (row && row.id);
        },
        beginStrategyAction(row, type, total) {
            this.strategyAction = {
                type,
                rowId: row && row.id || '',
                done: 0,
                total: Number(total || 0),
            };
        },
        updateStrategyActionProgress(done, failed, total) {
            if (!this.strategyAction.type) return;
            const d = Number(done || 0);
            const f = Number(failed || 0);
            const t = Number(total || this.strategyAction.total || 0);
            this.strategyAction = {
                ...this.strategyAction,
                done: d + f,
                total: t,
            };
        },
        clearStrategyAction() {
            this.strategyAction = {type: '', rowId: '', done: 0, total: 0};
        },
        strategyActionProgressText() {
            const total = Number(this.strategyAction.total || 0);
            if (!total) return '';
            const done = Math.min(Number(this.strategyAction.done || 0), total);
            return ` ${done}/${total}`;
        },
        strategyRunButtonText(row) {
            return this.isStrategyAction(row, 'run') ? `执行中${this.strategyActionProgressText()}` : '立即执行';
        },
        strategyApplyCountryRulesButtonText(row) {
            return this.isStrategyAction(row, 'apply_country_rules')
                ? `应用中${this.strategyActionProgressText()}`
                : '只应用国家';
        },
        strategyCleanupButtonText(row) {
            return this.isStrategyAction(row, 'cleanup') ? `移除中${this.strategyActionProgressText()}` : '移除Bidderdesk配置';
        },
        strategyDeleteButtonText(row) {
            return this.isStrategyAction(row, 'delete') ? '删除中' : '删除';
        },
        strategyScheduleLabel(t) {
            if (t === 'once') return '单次';
            if (t === 'repeat') return '按间隔重复';
            if (t === 'weekdays') return '按星期';
            return t || '—';
        },
        formatWeekdays(wds) {
            const arr = Array.isArray(wds) ? wds : [];
            const map = {0: '一', 1: '二', 2: '三', 3: '四', 4: '五', 5: '六', 6: '日'};
            const labels = [...new Set(arr.map((x) => Number(x) % 7))].sort((a, b) => a - b)
                .map((i) => '周' + map[i]);
            return labels.length ? labels.join('、') : '—';
        },
        gamProviderLabel(k) {
            const m = {premiumads: 'Premiumads', reklamup: 'Reklamup', a4g: 'A4G', bidderdesk: 'Bidderdesk'};
            return m[k] || k || '—';
        },
        apiErrorMessage(e, fallback) {
            const data = e && e.response && e.response.data;
            const payload = data && data.data || data || {};
            if (payload.errorMessage) return payload.errorMessage;
            if (payload.message) return payload.message;
            const status = e && e.response && e.response.status;
            const statusText = e && e.response && e.response.statusText;
            if (status) return `${fallback}: HTTP ${status}${statusText ? ' ' + statusText : ''}`;
            return fallback;
        },
        ammoDeleteErrorMessage(payload, fallback = '删除失败') {
            const data = payload || {};
            const base = data.errorMessage || fallback;
            const references = Array.isArray(data.references) ? data.references : [];
            const strategyLabels = [...new Set(references.map((ref) => (
                ref && (ref.strategy_name || ref.strategy_id)
            )).filter(Boolean))];
            if (!strategyLabels.length) return base;
            return `${base}（引用策略：${strategyLabels.join('、')}）`;
        },
        async requestDeleteAmmo(batchId) {
            try {
                const res = await axios.delete('/api/v2/gam/ammo/' + encodeURIComponent(batchId));
                const payload = res.data && res.data.data || {};
                if (!payload.deleted) {
                    ElMessage.error(this.ammoDeleteErrorMessage(payload));
                    return false;
                }
                return true;
            } catch (e) {
                const responseData = e && e.response && e.response.data;
                const payload = responseData && responseData.data || responseData || {};
                const fallback = this.apiErrorMessage(e, '删除失败');
                ElMessage.error(this.ammoDeleteErrorMessage(payload, fallback));
                return false;
            }
        },
        defaultPolicyForm() {
            return {
                country_targeting: {enabled: false, rule_set_id: '', allow_unmatched: false},
                provider_regex_replace: {enabled: false, providers: []},
            };
        },
        resetStrategyPolicyForm() {
            this.strategyPolicyForm = this.defaultPolicyForm();
        },
        countryRuleOptionLabel(rule) {
            const s = rule && rule.summary || {};
            const range = s.min_ecpm != null && s.max_ecpm != null ? `${s.min_ecpm}-${s.max_ecpm}` : '无区间';
            const unitText = s.unit_count ? ` · ${s.unit_count}个ADUnit` : '';
            return `${rule.name || rule.id} · ${range} · ${s.total || 0}段${unitText}`;
        },
        policyCountrySummary(policy) {
            const cfg = policy && policy.country_targeting || {};
            if (!cfg.enabled) return '未启用';
            const rule = (this.countryRuleSets || []).find((r) => r.id === cfg.rule_set_id);
            return rule ? this.countryRuleOptionLabel(rule) : (cfg.rule_set_name || cfg.rule_set_id || '已启用');
        },
        policyProviderSummary(policy) {
            const cfg = policy && policy.provider_regex_replace || {};
            if (!cfg.enabled) return '未启用';
            return (cfg.providers || []).map((p) => this.gamProviderLabel(p)).join('、') || '未选择';
        },
        buildPolicyConfig() {
            const country = this.strategyPolicyForm.country_targeting || {};
            const regex = this.strategyPolicyForm.provider_regex_replace || {};
            const out = {
                country_targeting: {
                    enabled: !!country.enabled,
                    rule_set_id: country.rule_set_id || '',
                    allow_unmatched: !!country.allow_unmatched,
                    none_behavior: 'disable_new_keep_existing',
                },
                provider_regex_replace: {
                    enabled: !!regex.enabled,
                    providers: [...new Set((regex.providers || []).map((x) => String(x)))],
                },
            };
            if (!out.country_targeting.enabled && !out.provider_regex_replace.enabled) {
                return {};
            }
            return out;
        },
        async loadCountryRuleSets() {
            this.countryRulesLoading = true;
            try {
                const res = await axios.get('/api/v2/gam/country_rules');
                this.countryRuleSets = res.data.data.list || [];
            } catch (e) {
                this.countryRuleSets = [];
                ElMessage.error('加载国家规则集失败');
            } finally {
                this.countryRulesLoading = false;
            }
        },
        openSelectedCountryRuleDetail() {
            const id = this.strategyPolicyForm.country_targeting.rule_set_id;
            if (!id) {
                ElMessage.warning('请先选择国家规则集');
                return;
            }
            this.openCountryRuleDetail(id);
        },
        _editableCountryRuleRows(rows) {
            return (rows || []).map((r) => ({
                min_ecpm: String(r.min_ecpm ?? ''),
                max_ecpm: String(r.max_ecpm ?? ''),
                countrys: String(r.countrys ?? ''),
            }));
        },
        async openCountryRuleDetail(ruleSetId) {
            this.countryRuleDetailOpen = true;
            this.countryRuleDetailLoading = true;
            this.countryRuleEditScope = '__global__';
            this.countryRuleEditForm = {
                id: '',
                name: '',
                product_id: '',
                source: '',
                report_start: '',
                report_end: '',
                summary: {},
                rules: [],
                unit_rules: {},
            };
            try {
                const res = await axios.get('/api/v2/gam/country_rules/' + encodeURIComponent(ruleSetId));
                const d = res.data.data || {};
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    this.countryRuleDetailOpen = false;
                    return;
                }
                const unitRules = {};
                Object.entries(d.unit_rules || {}).forEach(([uid, rows]) => {
                    unitRules[uid] = this._editableCountryRuleRows(rows);
                });
                this.countryRuleEditForm = {
                    id: d.id || ruleSetId,
                    name: d.name || '',
                    product_id: d.product_id || '',
                    source: d.source || '',
                    report_start: d.report_start || '',
                    report_end: d.report_end || '',
                    summary: d.summary || {},
                    rules: this._editableCountryRuleRows(d.rules || []),
                    unit_rules: unitRules,
                };
            } catch (e) {
                ElMessage.error(this.apiErrorMessage(e, '加载国家规则集失败'));
                this.countryRuleDetailOpen = false;
            } finally {
                this.countryRuleDetailLoading = false;
            }
        },
        addCountryRuleRow() {
            const row = {min_ecpm: '', max_ecpm: '', countrys: 'NONE'};
            if (this.countryRuleEditScope === '__global__') {
                this.countryRuleEditForm.rules.push(row);
                return;
            }
            if (!this.countryRuleEditForm.unit_rules[this.countryRuleEditScope]) {
                this.countryRuleEditForm.unit_rules[this.countryRuleEditScope] = [];
            }
            this.countryRuleEditForm.unit_rules[this.countryRuleEditScope].push(row);
        },
        removeCountryRuleRow(index) {
            this.countryRuleEditRows.splice(index, 1);
        },
        async saveCountryRuleDetail() {
            if (!this.countryRuleEditForm.id) {
                return;
            }
            if (!(this.countryRuleEditForm.name || '').trim()) {
                ElMessage.warning('请填写规则集名称');
                return;
            }
            this.countryRuleDetailSaving = true;
            try {
                const res = await axios.put('/api/v2/gam/country_rules/' + encodeURIComponent(this.countryRuleEditForm.id), {
                    name: (this.countryRuleEditForm.name || '').trim(),
                    product_id: (this.countryRuleEditForm.product_id || '').trim(),
                    rules: this.countryRuleEditForm.rules || [],
                    unit_rules: this.countryRuleEditForm.unit_rules || {},
                });
                const d = res.data.data || {};
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    return;
                }
                ElMessage.success('规则集已保存');
                await this.loadCountryRuleSets();
                await this.openCountryRuleDetail(this.countryRuleEditForm.id);
            } catch (e) {
                ElMessage.error(this.apiErrorMessage(e, '保存国家规则集失败'));
            } finally {
                this.countryRuleDetailSaving = false;
            }
        },
        openCountryRuleDialog() {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const ds = `${yyyy}-${mm}-${dd}`;
            this.countryRuleForm = {
                source: 'csv',
                name: '',
                product_id: '',
                csv_text: 'min_ecpm,max_ecpm,countrys\n0,0.1,NONE\n',
                start: ds,
                end: ds,
                coverage_min_ecpm: '0',
                coverage_max_ecpm: '93',
                coverage_step: '0.01',
                network_placements_text: '',
            };
            this.countryRuleOpen = true;
        },
        async submitCountryRule() {
            if (!(this.countryRuleForm.name || '').trim()) {
                ElMessage.warning('请填写规则集名称');
                return;
            }
            this.countryRuleSubmitLoading = true;
            try {
                let res;
                if (this.countryRuleForm.source === 'csv') {
                    if (!(this.countryRuleForm.csv_text || '').trim()) {
                        ElMessage.warning('请填写 CSV');
                        return;
                    }
                    res = await axios.post('/api/v2/gam/country_rules/from_csv', {
                        name: (this.countryRuleForm.name || '').trim(),
                        product_id: (this.countryRuleForm.product_id || '').trim(),
                        csv_text: this.countryRuleForm.csv_text || '',
                    });
                } else {
                    const unitIds = this._dedupeUnitIdList(this.strategySelectedUnitIds);
                    if (!unitIds.length) {
                        ElMessage.warning('请先选择要生成规则的 ADUnit');
                        return;
                    }
                    if (!this.countryRuleForm.start || !this.countryRuleForm.end) {
                        ElMessage.warning('请选择 report 日期');
                        return;
                    }
                    res = await axios.post('/api/v2/gam/country_rules/from_report', {
                        name: (this.countryRuleForm.name || '').trim(),
                        product_id: (this.countryRuleForm.product_id || '').trim(),
                        start: this.countryRuleForm.start,
                        end: this.countryRuleForm.end,
                        coverage_min_ecpm: this.countryRuleForm.coverage_min_ecpm || '0',
                        coverage_max_ecpm: this.countryRuleForm.coverage_max_ecpm || '93',
                        coverage_step: this.countryRuleForm.coverage_step || '0.01',
                        unit_ids: unitIds,
                        network_placements: (this.countryRuleForm.network_placements_text || '')
                            .split('\n').map((x) => x.trim()).filter(Boolean),
                    });
                }
                const d = res.data.data;
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    return;
                }
                if (d.async && d.job_id) {
                    const result = await this.waitRunJob(d.job_id, {
                        successMessage: '规则集已创建',
                        reloadStrategies: false,
                    });
                    if (!result) return;
                    if (!result.id) {
                        ElMessage.error('规则集任务完成但未返回规则集 id');
                        return;
                    }
                    this.countryRuleOpen = false;
                    await this.loadCountryRuleSets();
                    this.strategyPolicyForm.country_targeting.enabled = true;
                    this.strategyPolicyForm.country_targeting.rule_set_id = result.id;
                    return;
                }
                ElMessage.success('规则集已创建');
                this.countryRuleOpen = false;
                await this.loadCountryRuleSets();
                this.strategyPolicyForm.country_targeting.enabled = true;
                this.strategyPolicyForm.country_targeting.rule_set_id = d.id;
            } catch (e) {
                ElMessage.error(this.apiErrorMessage(e, '创建国家规则集失败'));
            } finally {
                this.countryRuleSubmitLoading = false;
            }
        },
        batchLabel(v) {
            return v === this.nextNewBatchId ? '下一新增批次' : (v || '—');
        },
        async openStrategyDetail(row) {
            this.strategyDetailOpen = true;
            this.strategyDetail = null;
            this.strategyDetailLoading = true;
            try {
                const res = await axios.get('/api/v2/gam/strategy/' + encodeURIComponent(row.id));
                const d = res.data.data;
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    this.strategyDetailOpen = false;
                    return;
                }
                this.strategyDetail = d;
            } catch (e) {
                ElMessage.error('加载策略详情失败');
                this.strategyDetailOpen = false;
            } finally {
                this.strategyDetailLoading = false;
            }
        },
        _dedupeUnitIdList(ids) {
            return [...new Set((ids || []).map((id) => String(id)))];
        },
        /** 只保留当前拉取到的单元列表里存在的 id，并去重（避免 localStorage / 合并产生脏数据） */
        _normalizeStrategySelectedToMaxUnits() {
            if (!this.strategyMaxUnits.length) {
                return;
            }
            const valid = new Set(this.strategyMaxUnits.map((u) => String(u.id)));
            this.strategySelectedUnitIds = this._dedupeUnitIdList(this.strategySelectedUnitIds).filter((id) => valid.has(id));
        },
        async loadStrategyMaxUnits() {
            this.strategyUnitSelectionSyncing = true;
            this.strategyUnitsLoading = true;
            try {
                const params = {};
                if (this.strategyExperimentMode) {
                    params.experiment_only = '1';
                }
                const res = await axios.get('/api/v1/max/unit', {params});
                this.strategyMaxUnits = res.data.data.unitList || [];
            } catch (e) {
                this.strategyMaxUnits = [];
                ElMessage.error('拉取广告单元失败');
            } finally {
                this.strategyUnitsLoading = false;
            }
            this._normalizeStrategySelectedToMaxUnits();
            await this.$nextTick();
            this.onStrategyUnitFilterChange();
        },
        async onStrategyExperimentModeChange() {
            await this.loadStrategyMaxUnits();
            if (this.strategyExperimentMode) {
                await this.loadCountryRuleSets();
            } else {
                this.resetStrategyPolicyForm();
            }
            const ids = new Set(this.strategyMaxUnits.map((u) => String(u.id)));
            this.strategySelectedUnitIds = this._dedupeUnitIdList(this.strategySelectedUnitIds).filter((id) => ids.has(id));
            await this.$nextTick();
            this.onStrategyUnitFilterChange();
            setLocalObj('selectedMaxUnit', this.strategySelectedUnitIds);
        },
        onStrategyUnitsSelectionChange(selection) {
            if (this.strategyUnitSelectionSyncing) {
                return;
            }
            const visibleIds = new Set(this.strategyUnitsFiltered.map((r) => String(r.id)));
            const selVisible = new Set(selection.map((r) => String(r.id)));
            const hiddenKept = this._dedupeUnitIdList(this.strategySelectedUnitIds).filter((id) => !visibleIds.has(id));
            this.strategySelectedUnitIds = this._dedupeUnitIdList([...hiddenKept, ...selVisible]);
            setLocalObj('selectedMaxUnit', this.strategySelectedUnitIds);
        },
        setWeekdayPreset(p) {
            if (p === '135') {
                this.strategyForm.weekdays = [0, 2, 4];
            } else if (p === '246') {
                this.strategyForm.weekdays = [1, 3, 5];
            } else if (p === 'all') {
                this.strategyForm.weekdays = [0, 1, 2, 3, 4, 5, 6];
            }
        },
        unitRowSelected(row) {
            return this.strategySelectedUnitIds.some(id => String(id) === String(row.id));
        },
        onStrategyUnitFilterChange() {
            this.strategyUnitSelectionSyncing = true;
            this.$nextTick(() => {
                const tb = this.$refs.strategyUnitsTable;
                if (!tb) {
                    this.strategyUnitSelectionSyncing = false;
                    return;
                }
                tb.clearSelection();
                this.strategyUnitsFiltered.forEach((row) => {
                    tb.toggleRowSelection(row, this.unitRowSelected(row));
                });
                this.$nextTick(() => {
                    this.strategyUnitSelectionSyncing = false;
                });
            });
        },
        _normalizeProviderCleanupSelection() {
            const valid = new Set((this.providerCleanupMaxUnits || []).map((u) => String(u.id)));
            this.providerCleanupSelectedUnitIds = this._dedupeUnitIdList(
                this.providerCleanupSelectedUnitIds,
            ).filter((id) => valid.has(id));
        },
        async loadProviderCleanupMaxUnits() {
            this.providerCleanupSelectionSyncing = true;
            try {
                const params = {};
                if (this.providerCleanupForm.target === 'experiment_only') {
                    params.experiment_only = '1';
                }
                const res = await axios.get('/api/v1/max/unit', {params});
                this.providerCleanupMaxUnits = res.data.data.unitList || [];
                this._normalizeProviderCleanupSelection();
            } catch (e) {
                this.providerCleanupMaxUnits = [];
                ElMessage.error(this.apiErrorMessage(e, '拉取广告单元失败'));
            }
            await this.$nextTick();
            this.syncProviderCleanupSelection();
        },
        async onProviderCleanupTargetChange() {
            this.providerCleanupLoading = true;
            try {
                await this.loadProviderCleanupMaxUnits();
            } finally {
                this.providerCleanupLoading = false;
            }
        },
        onProviderCleanupSelectionChange(selection) {
            if (this.providerCleanupSelectionSyncing) return;
            const visibleIds = new Set(this.providerCleanupUnitsFiltered.map((r) => String(r.id)));
            const selectedVisible = new Set((selection || []).map((r) => String(r.id)));
            const hiddenKept = this._dedupeUnitIdList(this.providerCleanupSelectedUnitIds)
                .filter((id) => !visibleIds.has(id));
            this.providerCleanupSelectedUnitIds = this._dedupeUnitIdList([
                ...hiddenKept,
                ...selectedVisible,
            ]);
        },
        syncProviderCleanupSelection() {
            this.providerCleanupSelectionSyncing = true;
            this.$nextTick(() => {
                const table = this.$refs.providerCleanupUnitsTable;
                if (!table) {
                    this.providerCleanupSelectionSyncing = false;
                    return;
                }
                table.clearSelection();
                const selected = new Set(this.providerCleanupSelectedUnitIds.map((id) => String(id)));
                this.providerCleanupUnitsFiltered.forEach((row) => {
                    table.toggleRowSelection(row, selected.has(String(row.id)));
                });
                this.$nextTick(() => {
                    this.providerCleanupSelectionSyncing = false;
                });
            });
        },
        copyProviderCleanupUnitsFromStrategy(strategyId) {
            if (!strategyId) return;
            const strategy = (this.strategyList || []).find((s) => s.id === strategyId);
            if (!strategy) {
                ElMessage.warning('未找到策略');
                return;
            }
            this.providerCleanupSelectedUnitIds = this._dedupeUnitIdList(strategy.unit_ids || []);
            this._normalizeProviderCleanupSelection();
            this.syncProviderCleanupSelection();
        },
        async openProviderCleanupDialog() {
            if (this.strategyActionBusy) return;
            this.providerCleanupForm = {providers: [], target: 'default_only'};
            this.providerCleanupSourceStrategyId = '';
            this.providerCleanupMaxUnits = [];
            this.providerCleanupSelectedUnitIds = [];
            this.providerCleanupUnitSearch = '';
            this.providerCleanupProductFilter = [];
            this.providerCleanupOpen = true;
            this.providerCleanupLoading = true;
            try {
                const res = await axios.get('/api/v2/gam/provider_cleanup');
                const d = res.data.data || {};
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    this.providerCleanupOpen = false;
                    return;
                }
                this.providerCleanupSpecs = d.providers || [];
                await this.loadProviderCleanupMaxUnits();
            } catch (e) {
                ElMessage.error(this.apiErrorMessage(e, '加载移除配置失败'));
                this.providerCleanupOpen = false;
            } finally {
                this.providerCleanupLoading = false;
            }
        },
        onProviderCleanupClosed() {
            this.providerCleanupSelectionSyncing = false;
        },
        providerCleanupTargetLabel(target) {
            const labels = {
                default_only: '仅默认瀑布',
                both: '默认瀑布 + 实验组',
                experiment_only: '仅实验组',
            };
            return labels[target] || target;
        },
        async submitProviderCleanup() {
            if (this.strategyActionBusy) return;
            const providers = [...new Set(this.providerCleanupForm.providers || [])];
            const unitIds = this._dedupeUnitIdList(this.providerCleanupSelectedUnitIds);
            if (!providers.length) {
                ElMessage.warning('请至少选择一家服务商');
                return;
            }
            if (!unitIds.length) {
                ElMessage.warning('请至少选择一个广告单元');
                return;
            }
            const providerLabels = this.providerCleanupSelectedSpecs.map((p) => p.label).join('、');
            try {
                await ElMessageBox.confirm(
                    `将从 ${unitIds.length} 个广告单元的「${this.providerCleanupTargetLabel(this.providerCleanupForm.target)}」中，删除命中 ${providerLabels} 正则的全部 placement。该操作不可自动撤销；后续策略执行可能重新写入。确定继续？`,
                    '确认移除配置',
                    {type: 'warning', confirmButtonText: '确认移除'},
                );
            } catch (e) {
                return;
            }
            this.beginStrategyAction({id: '__provider_cleanup__'}, 'provider_cleanup', unitIds.length);
            try {
                const res = await axios.post('/api/v2/gam/provider_cleanup', {
                    providers,
                    unit_ids: unitIds,
                    target: this.providerCleanupForm.target,
                });
                const submit = res.data.data || {};
                if (submit.errorMessage) {
                    ElMessage.error(submit.errorMessage);
                    return;
                }
                if (!submit.job_id) {
                    ElMessage.error('未返回任务 id');
                    return;
                }
                if (submit.duplicate) {
                    ElMessage.info('相同清理任务已在执行，将等待该任务结束');
                }
                const result = await this.waitRunJob(submit.job_id, {
                    total: unitIds.length,
                    reloadStrategies: false,
                    successMessage: (d) => (
                        `已检查 ${d.selected_unit_count || unitIds.length} 个广告单元，` +
                        `${d.changed_unit_count || 0} 个发生变更，共移除 ${d.removed_count || 0} 条配置`
                    ),
                });
                if (result) this.providerCleanupOpen = false;
            } catch (e) {
                ElMessage.error(this.apiErrorMessage(e, '提交移除配置失败'));
            } finally {
                this.clearStrategyAction();
            }
        },
        async loadAmmo() {
            this.ammoLoading = true;
            const offset = (this.ammoPage.page - 1) * this.ammoPage.size;
            try {
                const res = await axios.get('/api/v2/gam/ammo', {
                    params: {
                        provider: this.ammoFilter.provider || undefined,
                        search: this.ammoFilter.search || undefined,
                        limit: this.ammoPage.size,
                        offset,
                    },
                });
                this.ammoList = res.data.data.list || [];
                this.ammoPage.total = res.data.data.total || 0;
            } finally {
                this.ammoLoading = false;
            }
        },
        openPush() {
            this.pushForm = {provider: 'premiumads', text: ''};
            this.ammoPreview = null;
            this.pushOpen = true;
        },
        async openBidderdeskCreate() {
            this.bidderdeskOpen = true;
            this.bidderdeskLoading = true;
            this.bidderdeskDryRunResult = null;
            try {
                const res = await axios.get('/api/v2/gam/bidderdesk_ad_unit_template');
                const d = res.data.data;
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    this.bidderdeskOpen = false;
                    return;
                }
                this.bidderdeskForm = {
                    base_prefix: d.base_prefix || 'MAX',
                    batch_time: '',
                };
                this.bidderdeskTemplateText = JSON.stringify(d.template || [], null, 2);
                this.bidderdeskOrderTemplateText = JSON.stringify(d.order_template || {}, null, 2);
            } catch (e) {
                ElMessage.error('加载 Bidderdesk 模板失败');
                this.bidderdeskOpen = false;
            } finally {
                this.bidderdeskLoading = false;
            }
        },
        parseBidderdeskTemplateForSubmit() {
            let tpl;
            try {
                tpl = JSON.parse(this.bidderdeskTemplateText || '[]');
            } catch (e) {
                ElMessage.error('模板 JSON 格式错误');
                return null;
            }
            if (!Array.isArray(tpl) || !tpl.length) {
                ElMessage.warning('模板不能为空');
                return null;
            }
            return tpl;
        },
        parseBidderdeskOrderTemplateForSubmit() {
            let tpl;
            try {
                tpl = JSON.parse(this.bidderdeskOrderTemplateText || '{}');
            } catch (e) {
                ElMessage.error('订单模板 JSON 格式错误');
                return null;
            }
            if (!tpl || Array.isArray(tpl) || typeof tpl !== 'object') {
                ElMessage.warning('订单模板必须为对象');
                return null;
            }
            return tpl;
        },
        async submitBidderdeskCreate(dryRun) {
            const tpl = this.parseBidderdeskTemplateForSubmit();
            if (!tpl) {
                return;
            }
            const orderTpl = this.parseBidderdeskOrderTemplateForSubmit();
            if (!orderTpl) {
                return;
            }
            if (!dryRun) {
                try {
                    await ElMessageBox.confirm(
                        '将真实调用 GAM 创建广告单元和对应订单，订单创建成功后压入 Bidderdesk 弹夹数据库。确定继续？',
                        '确认创建',
                        {type: 'warning'},
                    );
                } catch (e) {
                    return;
                }
            }
            this.bidderdeskSubmitLoading = true;
            try {
                const res = await axios.post('/api/v2/gam/bidderdesk_ad_unit_template', {
                    action: 'create',
                    base_prefix: this.bidderdeskForm.base_prefix || 'MAX',
                    batch_time: this.bidderdeskForm.batch_time || '',
                    template: tpl,
                    order_template: orderTpl,
                    dry_run: dryRun,
                }, {timeout: 180000});
                const d = res.data.data;
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    return;
                }
                if (dryRun) {
                    this.bidderdeskDryRunResult = d;
                    ElMessage.success('dry-run 通过');
                    return;
                }
                ElMessage.success('已创建 GAM 广告单元和订单，并压入弹夹: ' + (d.batch_ids || []).join(', '));
                this.bidderdeskOpen = false;
                this.ammoFilter.provider = 'bidderdesk';
                this.ammoPage.page = 1;
                this.loadAmmo();
            } catch (e) {
                ElMessage.error('创建 Bidderdesk 弹夹失败');
            } finally {
                this.bidderdeskSubmitLoading = false;
            }
        },
        async cleanupBidderdeskPlacements(row) {
            if (!row || !row.id) {
                return;
            }
            if (this.strategyActionBusy) {
                return;
            }
            try {
                await ElMessageBox.confirm(
                    `将按策略「${row.name || row.id}」的执行范围，从 BN/INT/RW 瀑布中移除所有 Bidderdesk placement id，不会推进策略或消费弹夹。确定继续？`,
                    '确认清理',
                    {type: 'warning'},
                );
            } catch (e) {
                return;
            }
            this.beginStrategyAction(row, 'cleanup', (row.unit_ids || []).length);
            try {
                const res = await axios.post('/api/v2/gam/bidderdesk_ad_unit_template', {
                    action: 'cleanup_bidderdesk_placements',
                    strategy_id: row.id,
                });
                const submit = res.data.data;
                if (submit.errorMessage) {
                    ElMessage.error(submit.errorMessage);
                    return;
                }
                const jobId = submit.job_id;
                if (!jobId) {
                    ElMessage.error('未返回任务 id');
                    return;
                }
                if (submit.duplicate) {
                    ElMessage.info('已有任务在执行，将等待同一任务结束');
                }
                await this.waitRunJob(jobId, {
                    successMessage: (d) => `已移除 ${d.unit_count || 0} 个广告位中的 Bidderdesk 配置，共 ${d.removed_count || 0} 条`,
                    total: (row.unit_ids || []).length,
                });
            } catch (e) {
                ElMessage.error('提交移除 Bidderdesk 配置失败');
            } finally {
                this.clearStrategyAction();
            }
        },
        /** 与 bi-api _split_ammo_text 一致：空行分隔批次 */
        splitAmmoText(text) {
            return text.trim().split(/\n\s*\n/).filter(b => b.trim().length > 0);
        },
        /** 表头列名规范化，用于匹配 Type / AdCode / D.eCPM */
        normAmmoHeaderCell(h) {
            return String(h || '')
                .replace(/^\uFEFF/, '')
                .trim()
                .toLowerCase();
        },
        /** 简易 CSV 行解析（支持双引号字段） */
        parseCsvLine(line) {
            const out = [];
            let cur = '';
            let inQ = false;
            for (let i = 0; i < line.length; i++) {
                const c = line[i];
                if (inQ) {
                    if (c === '"') {
                        if (line[i + 1] === '"') {
                            cur += '"';
                            i++;
                        } else {
                            inQ = false;
                        }
                    } else {
                        cur += c;
                    }
                } else if (c === '"') {
                    inQ = true;
                } else if (c === ',') {
                    out.push(cur.trim());
                    cur = '';
                } else {
                    cur += c;
                }
            }
            out.push(cur.trim());
            return out;
        },
        findAmmoColumnIndices(headers) {
            const n = headers.map((h) => this.normAmmoHeaderCell(h));
            const ixType = n.findIndex((x) => x === 'type');
            const ixAd = n.findIndex((x) => x === 'adcode');
            const ixEcpm = n.findIndex((x) => x === 'd.ecpm' || x === 'decpm');
            if (ixType < 0 || ixAd < 0 || ixEcpm < 0) {
                return {
                    error: `表头须包含列 Type、AdCode、D.eCPM（当前列：${headers.join(', ')}）`,
                };
            }
            return {ixType, ixAd, ixEcpm};
        },
        validateAmmoRow(row, rawLine) {
            const snippet = String(rawLine || '').trim().slice(0, 400);
            const allow = ['BN', 'INT', 'NT', 'RW'];
            const tp = String(row.Type || '').trim().toUpperCase();
            if (!allow.includes(tp)) {
                return `Type 须为 BN、INT、NT、RW 之一，当前为 ${JSON.stringify(row.Type)}（行：${snippet}）`;
            }
            let cpm = row['D.eCPM'];
            if (cpm === null || cpm === undefined) {
                return `D.eCPM 不能为空（行：${snippet}）`;
            }
            if (typeof cpm === 'boolean') {
                return `D.eCPM 须为数字，当前为 ${JSON.stringify(cpm)}（行：${snippet}）`;
            }
            const n = Number(cpm);
            if (Number.isNaN(n)) {
                return `D.eCPM 格式错误，无法解析为数字：${JSON.stringify(row['D.eCPM'])}（行：${snippet}）`;
            }
            if (!Number.isFinite(n)) {
                return `D.eCPM 无效（非有限数字）（行：${snippet}）`;
            }
            if (n < 0) {
                return `D.eCPM 须为大于等于 0 的数字，当前为 ${n}（行：${snippet}）`;
            }
            const ac = row.AdCode;
            if (ac === null || ac === undefined || String(ac).trim() === '') {
                return `AdCode 不能为空（行：${snippet}）`;
            }
            return null;
        },
        finalizeAmmoEntry(typeStr, adcode, fv, rawLine) {
            const row = {
                Type: String(typeStr).trim().toUpperCase(),
                AdCode: adcode,
                'D.eCPM': Number(fv),
            };
            const err = this.validateAmmoRow(row, rawLine);
            if (err) {
                return {error: err};
            }
            return {row};
        },
        parseAmmoBlock(block) {
            const rawLines = block.trim().split('\n');
            const lines = [];
            for (const ln of rawLines) {
                const t = ln.trim();
                if (!t || t.startsWith('#')) {
                    continue;
                }
                lines.push(t);
            }
            if (!lines.length) {
                return {ok: false, error: '批次内无有效行（首行须为表头）', rows: []};
            }
            const headerLine = lines[0];
            const useTsv = headerLine.includes('\t');
            const headers = useTsv
                ? headerLine.split('\t').map((c) => c.trim())
                : this.parseCsvLine(headerLine);
            const col = this.findAmmoColumnIndices(headers);
            if (col.error) {
                return {ok: false, error: col.error, rows: []};
            }
            const {ixType, ixAd, ixEcpm} = col;
            const maxIx = Math.max(ixType, ixAd, ixEcpm);
            const rows = [];
            for (let i = 1; i < lines.length; i++) {
                const line = lines[i];
                const cells = useTsv
                    ? line.split('\t').map((c) => c.trim())
                    : this.parseCsvLine(line);
                if (cells.length <= maxIx) {
                    return {
                        ok: false,
                        error: `第 ${i + 1} 行列数不足（需含 Type、AdCode、D.eCPM 对应列）：${line.slice(0, 200)}`,
                        rows: [],
                    };
                }
                const typeStr = cells[ixType];
                const adcode = cells[ixAd];
                const ecpmRaw = cells[ixEcpm];
                const fv = parseFloat(String(ecpmRaw).trim());
                if (Number.isNaN(fv)) {
                    return {
                        ok: false,
                        error: `D.eCPM 格式错误：${JSON.stringify(ecpmRaw)}（第 ${i + 1} 行）`,
                        rows: [],
                    };
                }
                const fr = this.finalizeAmmoEntry(typeStr, adcode, fv, line);
                if (fr.error) {
                    return {ok: false, error: fr.error, rows: []};
                }
                rows.push(fr.row);
            }
            return {ok: true, error: null, rows};
        },
        /** 仅三列，与后端 _parse_ammo_line 的制表符分支兼容 */
        serializeAmmoRowForServer(e) {
            const t = String(e.Type || '').trim().toUpperCase();
            const ac = String(e.AdCode ?? '');
            const cpm = e['D.eCPM'];
            if (ac.includes('\t')) {
                const bits = ac.split('\t');
                return [t, ...bits, cpm].join('\t');
            }
            return [t, ac, cpm].join('\t');
        },
        serializeAmmoForServer(preview) {
            if (!preview || !preview.batches || !preview.batches.length) {
                return '';
            }
            const parts = [];
            for (const b of preview.batches) {
                if (b.parseError || !b.entries || !b.entries.length) {
                    continue;
                }
                parts.push(b.entries.map((e) => this.serializeAmmoRowForServer(e)).join('\n'));
            }
            return parts.join('\n\n');
        },
        buildAmmoPreviewResult() {
            const text = this.pushForm.text || '';
            const blocks = this.splitAmmoText(text);
            if (!blocks.length) {
                return {
                    ok: false,
                    topError: '无有效批次（请用空行分隔多个批次；每批第一行为表头）',
                    batches: [],
                    batchCount: 0,
                };
            }
            const batches = blocks.map((block, idx) => {
                const r = this.parseAmmoBlock(block);
                if (!r.ok) {
                    return {index: idx + 1, entries: [], parseError: r.error};
                }
                if (!r.rows.length) {
                    return {
                        index: idx + 1,
                        entries: [],
                        parseError: '每个批次至少需一条有效配置（Type,AdCode,D.eCPM）',
                    };
                }
                return {index: idx + 1, entries: r.rows, parseError: null};
            });
            const ok = !batches.some(b => b.parseError);
            return {ok, batches, topError: null, batchCount: blocks.length};
        },
        runAmmoPreview() {
            if (!this.pushForm.text.trim()) {
                this.ammoPreview = null;
                ElMessage.warning('请输入配置内容');
                return;
            }
            const result = this.buildAmmoPreviewResult();
            this.ammoPreview = {...result};
            if (result.topError) {
                ElMessage.warning(result.topError);
                return;
            }
            if (result.ok) {
                ElMessage.success('解析通过，可确认压入');
            } else {
                ElMessage.warning('存在错误，请修正后再压入');
            }
        },
        async submitPush() {
            if (!this.pushForm.text.trim()) {
                ElMessage.warning('请输入配置内容');
                return;
            }
            const check = this.buildAmmoPreviewResult();
            this.ammoPreview = {...check};
            if (!check.ok) {
                if (check.topError) {
                    ElMessage.warning(check.topError);
                } else {
                    ElMessage.warning('配置有误，请根据预览修正后再压入');
                }
                return;
            }
            this.pushLoading = true;
            try {
                const text = this.serializeAmmoForServer(check);
                if (!text.trim()) {
                    ElMessage.warning('无可压入内容');
                    return;
                }
                const res = await axios.post('/api/v2/gam/ammo', {
                    provider: this.pushForm.provider,
                    text,
                });
                if (res.data.data.errorMessage) {
                    ElMessage.error(res.data.data.errorMessage);
                    return;
                }
                ElMessage.success('已创建批次: ' + (res.data.data.batch_ids || []).join(', '));
                this.pushOpen = false;
                this.loadAmmo();
            } finally {
                this.pushLoading = false;
            }
        },
        async openAmmoDetail(batchId) {
            const res = await axios.get('/api/v2/gam/ammo/' + encodeURIComponent(batchId));
            if (res.data.data.errorMessage) {
                ElMessage.error(res.data.data.errorMessage);
                return;
            }
            this.ammoDetail = res.data.data;
            this.detailOpen = true;
        },
        async deleteAmmo() {
            if (!this.ammoDetail) return;
            try {
                await ElMessageBox.confirm('确定删除该弹夹？', '确认', {type: 'warning'});
            } catch (e) {
                return;
            }
            const deleted = await this.requestDeleteAmmo(this.ammoDetail.batch_id);
            if (!deleted) return;
            ElMessage.success('已删除');
            this.detailOpen = false;
            this.loadAmmo();
        },
        async deleteAmmoRow(row) {
            if (!row || !row.batch_id) return;
            try {
                await ElMessageBox.confirm(`确定删除弹夹 ${row.batch_id}？`, '确认', {type: 'warning'});
            } catch (e) {
                return;
            }
            const deleted = await this.requestDeleteAmmo(row.batch_id);
            if (!deleted) return;
            ElMessage.success('已删除');
            this.loadAmmo();
        },
        async loadStrategies() {
            this.strategyLoading = true;
            try {
                const res = await axios.get('/api/v2/gam/strategy');
                this.strategyList = res.data.data.strategies || [];
            } finally {
                this.strategyLoading = false;
            }
        },
        closeStrategyDialog() {
            this.strategyOpen = false;
        },
        onStrategyDialogClosed() {
            this.strategyEditId = null;
            this.strategyExperimentMode = false;
            this.strategyApplyCountryRulesAfterSave = false;
            this.resetStrategyPolicyForm();
        },
        openStrategyDialog() {
            this.strategyEditId = null;
            this.strategyExperimentMode = false;
            this.strategyApplyCountryRulesAfterSave = false;
            this.strategyForm = {
                name: '',
                schedule_type: 'once',
                run_at: '',
                first_run_at: '',
                interval_hours: 24,
                weekdays: [],
                weekday_run_time: '10:00:00',
            };
            this.resetStrategyPolicyForm();
            this.strategyMaxUnits = [];
            this.strategyUnitSearch = '';
            this.strategyUnitProductFilter = [];
            const saved = getLocalObj('selectedMaxUnit', []);
            this.strategySelectedUnitIds = (saved || []).map((x) => String(x));
            this.providerKeys.forEach(p => {
                p.enabled = p.key === 'premiumads';
                p.start_batch_id = '';
                p.batches = [];
            });
            this.strategyOpen = true;
            this.$nextTick(async () => {
                await this.loadStrategyMaxUnits();
                await Promise.all(this.providerKeys.map((p) => this.fetchBatchesFor(p)));
                await this.loadCountryRuleSets();
            });
        },
        applyStrategyDetailToForm(d) {
            const st = d.schedule_type || 'once';
            const wds = (d.weekdays || []).map((x) => Number(x) % 7);
            this.strategyExperimentMode = d.ad_update_target === 'experiment_only';
            this.strategyApplyCountryRulesAfterSave = false;
            this.strategyForm = {
                name: d.name || '',
                schedule_type: st,
                run_at: d.run_at || '',
                first_run_at: d.first_run_at || '',
                interval_hours: d.interval_hours != null ? d.interval_hours : 24,
                weekdays: st === 'weekdays' ? wds : [],
                weekday_run_time: d.weekday_run_time || '10:00:00',
            };
            this.strategySelectedUnitIds = (d.unit_ids || []).map((x) => String(x));
            const policy = d.policy_config || {};
            this.strategyPolicyForm = {
                country_targeting: {
                    enabled: !!(policy.country_targeting && policy.country_targeting.enabled),
                    rule_set_id: policy.country_targeting && policy.country_targeting.rule_set_id || '',
                    allow_unmatched: !!(policy.country_targeting && policy.country_targeting.allow_unmatched),
                },
                provider_regex_replace: {
                    enabled: !!(policy.provider_regex_replace && policy.provider_regex_replace.enabled),
                    providers: policy.provider_regex_replace && Array.isArray(policy.provider_regex_replace.providers)
                        ? [...policy.provider_regex_replace.providers]
                        : [],
                },
            };
            this.strategyUnitSearch = '';
            this.strategyUnitProductFilter = [];
            this.providerKeys.forEach((p) => {
                const sub = (d.subscriptions || []).find((s) => s.provider === p.key);
                p.enabled = !!sub;
                p.start_batch_id = sub ? (sub.start_batch_id || sub.cursor_batch_id || '') : '';
                p.batches = [];
            });
        },
        async openEditStrategyAfterPrefill() {
            this.strategyOpen = true;
            await this.loadStrategyMaxUnits();
            await Promise.all(this.providerKeys.map((p) => this.fetchBatchesFor(p)));
            await this.loadCountryRuleSets();
        },
        async openCopyStrategy(row) {
            try {
                const res = await axios.get('/api/v2/gam/strategy/' + encodeURIComponent(row.id));
                const d = res.data.data;
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    return;
                }
                this.strategyEditId = null;
                this.applyStrategyDetailToForm({
                    ...d,
                    name: (d.name || '') + ' 复制',
                });
                await this.openEditStrategyAfterPrefill();
            } catch (e) {
                ElMessage.error('复制策略失败');
            }
        },
        async openEditStrategy(row) {
            if (row.status === 'done') {
                ElMessage.warning('已完成策略不可编辑，请新建策略');
                return;
            }
            try {
                const res = await axios.get('/api/v2/gam/strategy/' + encodeURIComponent(row.id));
                const d = res.data.data;
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    return;
                }
                this.strategyEditId = row.id;
                this.applyStrategyDetailToForm(d);
                await this.openEditStrategyAfterPrefill();
            } catch (e) {
                ElMessage.error('加载策略失败');
            }
        },
        editFromDetail() {
            if (!this.strategyDetail || this.strategyDetail.status === 'done') {
                return;
            }
            this.strategyEditId = this.strategyDetail.id;
            this.applyStrategyDetailToForm(this.strategyDetail);
            this.strategyDetailOpen = false;
            this.$nextTick(() => this.openEditStrategyAfterPrefill());
        },
        async fetchBatchesFor(p) {
            p.loading = true;
            try {
                const res = await axios.get('/api/v2/gam/provider/' + p.key + '/batches');
                p.batches = res.data.data.batches || [];
            } catch (e) {
                p.batches = [];
            } finally {
                p.loading = false;
            }
        },
        resetManualProviderKeys() {
            this.manualProviderKeys.forEach((p) => {
                p.enabled = p.key === 'premiumads';
                p.start_batch_id = '';
                p.batches = [];
            });
        },
        async openManualRunDialog() {
            this.manualRunForm = {strategy_id: ''};
            this.manualRunSourceDetail = null;
            this.resetManualProviderKeys();
            this.manualRunOpen = true;
            await Promise.all(this.manualProviderKeys.map((p) => this.fetchBatchesFor(p)));
        },
        async onManualRunStrategyChange(strategyId) {
            this.manualRunSourceDetail = null;
            if (!strategyId) {
                return;
            }
            try {
                const res = await axios.get('/api/v2/gam/strategy/' + encodeURIComponent(strategyId));
                const d = res.data.data;
                if (d.errorMessage) {
                    ElMessage.error(d.errorMessage);
                    return;
                }
                this.manualRunSourceDetail = d;
            } catch (e) {
                ElMessage.error('加载策略失败');
            }
        },
        async submitManualRun() {
            if (this.strategyActionBusy) {
                return;
            }
            if (!this.manualRunForm.strategy_id || !this.manualRunSourceDetail) {
                ElMessage.warning('请选择要复制 ADUnit 的策略');
                return;
            }
            const subs = [];
            for (const p of this.manualProviderKeys) {
                if (!p.enabled) {
                    continue;
                }
                if (!p.start_batch_id) {
                    ElMessage.warning(`请选择 ${p.label} 弹夹`);
                    return;
                }
                subs.push({provider: p.key, start_batch_id: p.start_batch_id});
            }
            if (!subs.length) {
                ElMessage.warning('至少选择一个服务商和弹夹');
                return;
            }
            const total = (this.manualRunSourceDetail.unit_ids || []).length;
            try {
                await ElMessageBox.confirm(
                    `将复制策略「${this.manualRunSourceDetail.name || this.manualRunForm.strategy_id}」的 ${total} 个 ADUnit，用本次选择的弹夹按正常策略流程立即更新 Max；成功后会写入快照、消费记录并推进策略游标。确定执行？`,
                    '确认手动修复执行',
                    {type: 'warning'},
                );
            } catch (e) {
                return;
            }
            this.beginStrategyAction({id: '__manual_run__'}, 'manual_run', total);
            try {
                const res = await axios.post('/api/v2/gam/manual_run', {
                    strategy_id: this.manualRunForm.strategy_id,
                    subscriptions: subs,
                    ad_update_target: this.manualRunSourceDetail.ad_update_target || 'all',
                });
                const submit = res.data.data;
                if (submit.errorMessage) {
                    ElMessage.error(submit.errorMessage);
                    return;
                }
                const jobId = submit.job_id;
                if (!jobId) {
                    ElMessage.error('未返回任务 id');
                    return;
                }
                await this.waitRunJob(jobId, {
                    successMessage: () => '手动修复执行完成',
                    total,
                });
                this.manualRunOpen = false;
            } catch (e) {
                ElMessage.error('提交手动修复执行失败');
            } finally {
                this.clearStrategyAction();
            }
        },
        async submitStrategy() {
            const subs = [];
            for (const p of this.providerKeys) {
                if (p.enabled) {
                    if (!p.start_batch_id) {
                        ElMessage.warning(`请选择 ${p.label} 起始批次`);
                        return;
                    }
                    subs.push({provider: p.key, start_batch_id: p.start_batch_id});
                }
            }
            if (!subs.length) {
                ElMessage.warning('至少订阅一个服务商');
                return;
            }
            let schedule;
            if (this.strategyForm.schedule_type === 'once') {
                schedule = {type: 'once', run_at: this.strategyForm.run_at};
            } else if (this.strategyForm.schedule_type === 'repeat') {
                schedule = {
                    type: 'repeat',
                    first_run_at: this.strategyForm.first_run_at,
                    interval_hours: this.strategyForm.interval_hours,
                };
            } else {
                schedule = {
                    type: 'weekdays',
                    weekdays: (this.strategyForm.weekdays || []).map((x) => Number(x) % 7),
                    weekday_run_time: this.strategyForm.weekday_run_time || '10:00:00',
                };
            }
            if (this.strategyForm.schedule_type === 'once' && !this.strategyForm.run_at) {
                ElMessage.warning('请选择执行时间');
                return;
            }
            if (this.strategyForm.schedule_type === 'repeat' && (!this.strategyForm.first_run_at || !this.strategyForm.interval_hours)) {
                ElMessage.warning('请填写重复调度');
                return;
            }
            if (this.strategyForm.schedule_type === 'weekdays') {
                if (!(this.strategyForm.weekdays || []).length) {
                    ElMessage.warning('请至少选择一个星期');
                    return;
                }
                if (!this.strategyForm.weekday_run_time) {
                    ElMessage.warning('请选择执行时刻');
                    return;
                }
            }
            if (!this.strategySelectedUnitCount) {
                ElMessage.warning('请至少选择一个广告单元');
                return;
            }
            if (!(this.strategyForm.name || '').trim()) {
                ElMessage.warning('请填写策略名称');
                return;
            }
            const policyConfig = this.buildPolicyConfig();
            if (policyConfig.country_targeting && policyConfig.country_targeting.enabled && !policyConfig.country_targeting.rule_set_id) {
                ElMessage.warning('请选择国家规则集');
                return;
            }
            if (
                policyConfig.provider_regex_replace
                && policyConfig.provider_regex_replace.enabled
                && !(policyConfig.provider_regex_replace.providers || []).length
            ) {
                ElMessage.warning('请选择要正则替换的 provider');
                return;
            }
            this.strategySubmitLoading = true;
            try {
                const payload = {
                    name: (this.strategyForm.name || '').trim(),
                    unit_ids: this._dedupeUnitIdList(this.strategySelectedUnitIds),
                    subscriptions: subs,
                    schedule,
                    ad_update_target: this.strategyExperimentMode ? 'experiment_only' : 'all',
                    policy_config: policyConfig,
                };
                const res = this.strategyEditId
                    ? await axios.put('/api/v2/gam/strategy/' + encodeURIComponent(this.strategyEditId), payload)
                    : await axios.post('/api/v2/gam/strategy', payload);
                const saved = res.data.data || {};
                if (saved.errorMessage) {
                    ElMessage.error(saved.errorMessage);
                    return;
                }
                const shouldApplyCountryRules = (
                    this.strategyApplyCountryRulesAfterSave
                    && this.strategyExperimentMode
                    && policyConfig.country_targeting
                    && policyConfig.country_targeting.enabled
                    && policyConfig.country_targeting.rule_set_id
                    && saved.id
                );
                ElMessage.success(this.strategyEditId ? '策略已保存' : '策略已创建');
                this.closeStrategyDialog();
                await this.loadStrategies();
                if (shouldApplyCountryRules) {
                    await this.applyCountryRules(saved, {
                        confirm: false,
                        successMessage: '国家规则已应用',
                    });
                }
            } finally {
                this.strategySubmitLoading = false;
            }
        },
        async applyCountryRules(row, options = {}) {
            if (this.strategyActionBusy) {
                return;
            }
            if (!row || !row.id) {
                ElMessage.warning('策略 ID 缺失');
                return;
            }
            if (!this.strategyCanApplyCountryRules(row)) {
                ElMessage.warning('仅实验组且已启用国家规则的策略可以只应用国家');
                return;
            }
            if (options.confirm !== false) {
                try {
                    await ElMessageBox.confirm(
                        `将只按策略「${row.name || row.id}」当前绑定的国家规则更新实验组 GAM 国家。确定继续？`,
                        '确认只应用国家规则',
                        {type: 'warning'},
                    );
                } catch (e) {
                    return;
                }
            }
            this.beginStrategyAction(row, 'apply_country_rules', (row.unit_ids || []).length);
            let post;
            try {
                post = await axios.post('/api/v2/gam/strategy/' + encodeURIComponent(row.id) + '/apply_country_rules');
            } catch (e) {
                ElMessage.error(this.apiErrorMessage(e, '提交只应用国家规则失败'));
                this.clearStrategyAction();
                return;
            }
            const submit = post.data.data || {};
            if (submit.errorMessage) {
                ElMessage.error(submit.errorMessage);
                this.clearStrategyAction();
                return;
            }
            const jobId = submit.job_id;
            if (!jobId) {
                ElMessage.error('未返回任务 id');
                this.clearStrategyAction();
                return;
            }
            if (submit.duplicate) {
                ElMessage.info('已有任务在执行，将等待同一任务结束');
            }
            try {
                await this.waitRunJob(jobId, {
                    successMessage: options.successMessage || '国家规则已应用',
                    total: (row.unit_ids || []).length,
                });
            } finally {
                this.clearStrategyAction();
            }
        },
        async runStrategy(row) {
            if (this.strategyActionBusy) {
                return;
            }
            if (row.paused) {
                ElMessage.warning('策略已暂停，跳过运行');
                return;
            }
            this.beginStrategyAction(row, 'run', (row.unit_ids || []).length);
            let post;
            try {
                post = await axios.post('/api/v2/gam/strategy/' + encodeURIComponent(row.id) + '/run');
            } catch (e) {
                ElMessage.error('提交执行失败');
                this.clearStrategyAction();
                return;
            }
            const submit = post.data.data;
            if (submit.errorMessage) {
                ElMessage.error(submit.errorMessage);
                this.clearStrategyAction();
                return;
            }
            const jobId = submit.job_id;
            if (!jobId) {
                ElMessage.error('未返回任务 id');
                this.clearStrategyAction();
                return;
            }
            if (submit.duplicate) {
                ElMessage.info('已有任务在执行，将等待同一任务结束');
            }
            try {
                await this.waitRunJob(jobId, {
                    successMessage: () => '执行完成',
                    total: (row.unit_ids || []).length,
                });
            } finally {
                this.clearStrategyAction();
            }
        },
        async waitRunJob(jobId, options = {}) {
            // 与 Max 多单元 + 重试 + 读超时叠加时单任务可能 20～40+ 分钟；过短会误判超时但 worker 仍在跑；running 超 30 分钟服务端会回收为 failed
            const pollIntervalMs = 1500;
            const maxPoll = 3000;
            const pollGetTimeoutMs = 180000;
            const maxWaitMinutes = Math.round(((maxPoll - 1) * pollIntervalMs) / 60000);
            const reloadStrategies = () => {
                if (options.reloadStrategies !== false) this.loadStrategies();
            };
            for (let i = 0; i < maxPoll; i++) {
                if (i > 0) {
                    await new Promise((resolve) => setTimeout(resolve, pollIntervalMs));
                }
                let jr;
                try {
                    const res = await axios.get('/api/v2/gam/run_job/' + encodeURIComponent(jobId), {
                        timeout: pollGetTimeoutMs,
                    });
                    jr = res.data.data;
                } catch (e) {
                    ElMessage.error('查询执行状态失败');
                    return null;
                }
                if (jr.errorMessage && !jr.status) {
                    ElMessage.error(jr.errorMessage);
                    return null;
                }
                const st = jr.status;
                this.updateStrategyActionProgress(
                    jr.progress_done_units,
                    jr.progress_failed_units,
                    options.total,
                );
                if (st === 'pending' || st === 'running') {
                    continue;
                }
                if (st === 'failed') {
                    ElMessage.error(jr.error_message || '执行失败');
                    reloadStrategies();
                    return null;
                }
                if (st === 'done') {
                    const d = jr.result || {};
                    if (d.errorMessage) {
                        ElMessage.error(d.errorMessage);
                        reloadStrategies();
                        return null;
                    }
                    if (d.skipped) {
                        ElMessage.warning(d.reason === 'paused' ? '策略已暂停，跳过运行' : '已跳过：' + (d.reason || ''));
                        reloadStrategies();
                        return null;
                    }
                    const successMessage = typeof options.successMessage === 'function'
                        ? options.successMessage(d, jr)
                        : (options.successMessage || '执行完成');
                    ElMessage.success(successMessage);
                    reloadStrategies();
                    return d;
                }
                ElMessage.warning('未知任务状态：' + (st || ''));
                reloadStrategies();
                return null;
            }
            ElMessage.error(
                '等待执行结果超时（约 ' +
                    maxWaitMinutes +
                    ' 分钟）。任务可能仍在服务端执行，请刷新列表或 GET /api/v2/gam/run_job/' +
                    jobId +
                    '；若 started_at 起超过 30 分钟仍为 running，服务端会自动标记失败以便重试',
            );
            reloadStrategies();
            return null;
        },
        async togglePause(row) {
            await axios.put('/api/v2/gam/strategy/' + row.id, {paused: !row.paused});
            ElMessage.success('已更新');
            this.loadStrategies();
        },
        async removeStrategy(row) {
            if (this.strategyActionBusy) {
                return;
            }
            try {
                await ElMessageBox.confirm('删除策略？', '确认', {type: 'warning'});
            } catch (e) {
                return;
            }
            this.beginStrategyAction(row, 'delete', 0);
            try {
                await axios.delete('/api/v2/gam/strategy/' + row.id);
                ElMessage.success('已删除');
                this.loadStrategies();
            } finally {
                this.clearStrategyAction();
            }
        },
    },
};
</script>

<style scoped>
.unit-name-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.provider-regex-list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.provider-regex-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px 10px;
    border: 1px solid var(--el-border-color);
    border-radius: 4px;
    background: var(--el-fill-color-light);
}

.provider-regex-item code {
    white-space: pre-wrap;
    word-break: break-all;
    font-size: 12px;
}
</style>
